<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import { mapActions, mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/functions";
const _ = require("lodash");
import { PDFDocument } from "pdf-lib";
import moment from "moment";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";
import * as XLSX from "xlsx";
import ConfirmDocumentDialog from "@/components/admin/automation/confirm-document-dialog.vue";
import ConfirmSingleDocumentDialog from "@/components/admin/automation/confirm-single-document-dialog.vue";
import BasicConfirmDialog from "@/components/admin/automation/basic-confirm-dialog.vue";
import ConfirmDeleteDialog from "@/components/admin/automation/confirm-delete-dialog.vue";
import LoadingAnimation from "@/components/admin/automation/loading-animation.vue";
import DoclineFormDialog from "@/components/admin/automation/docline-form-dialog.vue";
import { INVOICE_STATUS, INVOICE_FILE_TYPE, EVENT_TYPES } from "@/libs/libConstant";
import { cloneDeep } from "lodash";
import logActivity from "@/libs/activityLogger";
import loading from "@/store/modules/loading";
import { logUserActivity, logUserActivityBatch } from "@/libs/activityUserLogger";

// Default status list for filtering - SUCCESS only
const DEFAULT_STATUS_LIST = [
  "SUCCESS",
];

export default {
  name: "documents.accountspayable.success",
  components: {
    DateRangeSearch,
    ConfirmDocumentDialog,
    ConfirmSingleDocumentDialog,
    ConfirmDeleteDialog,
    LoadingAnimation,
    DoclineFormDialog,
    BasicConfirmDialog,
    Admin,
  },
  data() {
    return {
      sortBy: localStorage.getItem("apSortBy") || "docDate", // Column to sort by
      sortDirection: localStorage.getItem("apSortDirection") || "asc", // Sort direction: 'asc' or 'desc'
      vendorId: "",
      companyId: "",
      snackbar: {
        isShow: false,
        color: "",
        text: "",
      },
      purchaseInvoices: [], // Full list of purchase orders
      displayedItems: [], // Items to display on the current page
      currentPage: 1, // Current page
      itemsPerPage:
        localStorage.getItem("pageLimit") &&
        localStorage.getItem("pageLimit") === "auto"
          ? 10
          : Number.parseInt(localStorage.getItem("pageLimit")) || 10, // Items per page
      totalItems: 0, // Total number of items
      selectedItems: [], // Selected POIDs
      selectAll: false, // Select all flag
      dialogDelete: false, // Dialog for confirmation
      selectedDoc: [], // Selected Docline data (array)
      unsubscribe: null, // Listener to unsubscribe from Firestore updates
      editMode: false, // Flag to track edit mode
      isUpdating: false,
      selectedDocCopy: null,
      selectedDocIdCopy: null,
      dialogConfirmDocument: false,
      dialogConfirmDocumentOne: false,
      purchasePdfFile: null,
      queryText: null,
      isGettingPdfData: false,
      isGettingImageData: false,
      pdfUrl: "",
      imageUrl: "",
      isOpenPiDateMenu: false,
      isOpenPiDueDateMenu: false,
      isOpenPiDateMenuSearch: false,
      isOpenFromDatePoMenuSearch: false,
      isOpenToDatePoMenuSearch: false,
      selectedPiDueDate: "",
      selectedPiDate: "",
      PiDateDisp: "",
      PiDueDateDisp: "",
      dateSearchDisp: "",
      fromDateSearch: "",
      toDateSearch: "",
      toDateDsp: "",
      fromDateDsp: "",
      searchDocID: "",
      searchStatus: INVOICE_STATUS.SUCCESS,
      searchSource: "SHOW_ALL",
      sourceOptions: [
        { text: "ทั้งหมด", value: "SHOW_ALL" },
        { text: "AI", value: "AI" },
        { text: "Manual", value: "MANUAL" },
      ],
      searchStartDate: null,
      searchEndDate: null,
      aiSearchEnabled: false,
      aiSearchResults: [],
      searchKeywords: "",
      selectedSearchColumn: "docId",
      snackbarCopy: false,
      snackbarNotFound: false,
      docStatusList: [
        {
          text: "New",
          value: "NEW",
          colorClass: "new-color",
        },
        {
          text: "Pending",
          value: "PENDING_APPROVAL",
          colorClass: "pending-color",
        },
        {
          text: "Posting",
          value: "CONFIRMED",
          colorClass: "posting-color",
        },
        {
          text: "Posting",
          value: "POSTING",
          colorClass: "posting-color",
        },
        {
          text: "Warning",
          value: "FAILURE",
          colorClass: "warning-color",
        },
        {
          text: "Warning",
          value: "WARNING",
          colorClass: "warning-color",
        },
        {
          text: "Error",
          value: "ERROR",
          colorClass: "error-color",
        },
        // {
        //   text: "Invalid",
        //   value: "INVALID",
        //   colorClass: "error-color",
        // },
        {
          text: "Success",
          value: "SUCCESS",
          colorClass: "success-color",
        },
      ],
      docToDelete: null,
      isOpenCustomDialogue: false,

      searchKeywordsTo: "",

      // Export Dialog
      exportDialog: false,
      isExporting: false,
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      dateExportStart: null,
      dateExportEnd: null,
      isOpenMenuPaymentDate: false,
      selectedPaymentDate: "",
      selectedPaymentDateDisp: "",
      isLoadingDocs: false,
      currencies: [
        {
          code: "THB",
          name: "THB - Thai Baht",
        },
        {
          code: "USD",
          name: "USD - US Dollar",
        },
        {
          code: "EUR",
          name: "EUR - Euro",
        },
      ],
      isZoomed: false,
      mouseX: 0,
      mouseY: 0,
      piStatus: INVOICE_STATUS,
      piFileType: INVOICE_FILE_TYPE,
      popupTableHeaders: [
        { titleEN: "No.", titleTH: "ลำดับ" },
        { titleEN: "Expense Code", titleTH: "รหัสค่าใช้จ่าย" },
        { titleEN: "Expense", titleTH: "ค่าใช้จ่าย" },
        { titleEN: "VAT Code", titleTH: "รหัส VAT" },
        { titleEN: "Total Before VAT", titleTH: "มูลค่ารวมก่อน VAT" },
        { titleEN: "VAT Amount", titleTH: "มูลค่า VAT" },
        { titleEN: "Gross Price", titleTH: "มูลค่ารวม VAT" },
        { titleEN: "WHT Code", titleTH: "รหัส WHT" },
        { titleEN: "WHT (%)", titleTH: "อัตรา WHT" },
        { titleEN: "Cost Center 1", titleTH: "Cost Center 1", type: "SAP" },
        { titleEN: "Cost Center 2", titleTH: "Cost Center 2", type: "SAP" },
        { titleEN: "Cost Center 3", titleTH: "Cost Center 3", type: "SAP" },
      ],
      isDoclineDialogOpen: false,
      doclineToEdit: {}, // Holds the docline being edited
      dialogRefreshDocument: false,
      doclineToEditIndex: -1,
      isEditModeDocline: false,
      isGettingDefaultVendor: false,
      isRefreshingDoc: false,
      isConfirmingDoc: false,
      companyProductType: "AP_AUTOMATION",
      piDateValidationTimer: null,
      piDueDateValidationTimer: null,
      paymentDateValidationTimer: null,
      taxPeriodList: []
    };
  },
  created() {
    let companyId = this.$route.params.companyId;
    if (companyId) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyId });
      this.fetchPayAcctList({ companyId: companyId });
      this.fetchExpenseList({ companyId: companyId });
      this.fetchWhtList({ companyId: companyId });
      this.fetchVatList({ companyId: companyId });
      this.$store.dispatch("companies/fetchApVendors", {
        companyId: companyId,
      });
    }
  },
  methods: {
    validateAndFormatPiDate() {
      if (!this.PiDateDisp || !this.editMode) return;

      // Remove any non-numeric characters except /
      let value = this.PiDateDisp.replace(/[^\d/]/g, '');

      // Try to parse the date
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // JavaScript months are 0-indexed
        const year = parseInt(parts[2]);

        // Handle 2-digit year
        const fullYear = year < 100 ? (year > 50 ? 1900 + year : 2000 + year) : year;

        // Validate the date
        const date = new Date(fullYear, month, day);
        if (date && date.getDate() === day && date.getMonth() === month && date.getFullYear() === fullYear) {
          // Valid date
          this.selectedDoc.docDate = date;
          this.selectedPiDate = `${fullYear}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          this.PiDateDisp = `${String(day).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}/${fullYear}`;
        } else {
          // Invalid date, revert to previous value
          if (this.selectedDoc.docDate) {
            const prevDate = new Date(this.selectedDoc.docDate);
            const prevDay = prevDate.getDate();
            const prevMonth = prevDate.getMonth() + 1;
            const prevYear = prevDate.getFullYear();
            this.PiDateDisp = `${String(prevDay).padStart(2, '0')}/${String(prevMonth).padStart(2, '0')}/${prevYear}`;
          } else {
            this.PiDateDisp = '';
          }
        }
      } else if (value === '') {
        // Allow clearing the date
        this.PiDateDisp = '';
        this.selectedPiDate = '';
      } else {
        // Invalid format, revert to previous value
        if (this.selectedDoc.docDate) {
          const prevDate = new Date(this.selectedDoc.docDate);
          const prevDay = prevDate.getDate();
          const prevMonth = prevDate.getMonth() + 1;
          const prevYear = prevDate.getFullYear();
          this.PiDateDisp = `${String(prevDay).padStart(2, '0')}/${String(prevMonth).padStart(2, '0')}/${prevYear}`;
        } else {
          this.PiDateDisp = '';
        }
      }
    },
    validateAndFormatPiDueDate() {
      if (!this.editMode) return;

      // Remove any non-numeric characters except /
      let value = this.PiDueDateDisp.replace(/[^\d/]/g, '');

      // Try to parse the date
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // JavaScript months are 0-indexed
        const year = parseInt(parts[2]);

        // Handle 2-digit year
        const fullYear = year < 100 ? (year > 50 ? 1900 + year : 2000 + year) : year;

        // Validate the date
        const date = new Date(fullYear, month, day);
        if (date && date.getDate() === day && date.getMonth() === month && date.getFullYear() === fullYear) {
          // Valid date
          this.selectedDoc.docDueDate = date;
          this.selectedPiDueDate = `${fullYear}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          this.PiDueDateDisp = `${String(day).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}/${fullYear}`;
        } else {
          // Invalid date, revert to previous value
          if (this.selectedDoc.docDueDate && this.selectedDoc.docDueDate !== '' && this.selectedDoc.docDueDate !== 'Invalid Date') {
            const prevDate = new Date(this.selectedDoc.docDueDate);
            if (!isNaN(prevDate.getTime())) {
              const prevDay = prevDate.getDate();
              const prevMonth = prevDate.getMonth() + 1;
              const prevYear = prevDate.getFullYear();
              this.PiDueDateDisp = `${String(prevDay).padStart(2, '0')}/${String(prevMonth).padStart(2, '0')}/${prevYear}`;
            } else {
              this.PiDueDateDisp = '';
            }
          } else {
            this.PiDueDateDisp = '';
          }
        }
      } else if (value === '') {
        // Allow clearing the due date (unlike document date and payment date)
        this.PiDueDateDisp = '';
        this.selectedPiDueDate = '';
        this.selectedDoc.docDueDate = '';
      } else {
        // Invalid format, revert to previous value
        if (this.selectedDoc.docDueDate && this.selectedDoc.docDueDate !== '' && this.selectedDoc.docDueDate !== 'Invalid Date') {
          const prevDate = new Date(this.selectedDoc.docDueDate);
          if (!isNaN(prevDate.getTime())) {
            const prevDay = prevDate.getDate();
            const prevMonth = prevDate.getMonth() + 1;
            const prevYear = prevDate.getFullYear();
            this.PiDueDateDisp = `${String(prevDay).padStart(2, '0')}/${String(prevMonth).padStart(2, '0')}/${prevYear}`;
          } else {
            this.PiDueDateDisp = '';
          }
        } else {
          this.PiDueDateDisp = '';
        }
      }
    },
    validateAndFormatPaymentDate() {
      if (!this.selectedPaymentDateDisp || !this.editMode) return;

      // Remove any non-numeric characters except /
      let value = this.selectedPaymentDateDisp.replace(/[^\d/]/g, '');

      // Try to parse the date
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // JavaScript months are 0-indexed
        const year = parseInt(parts[2]);

        // Handle 2-digit year
        const fullYear = year < 100 ? (year > 50 ? 1900 + year : 2000 + year) : year;

        // Validate the date
        const date = new Date(fullYear, month, day);
        if (date && date.getDate() === day && date.getMonth() === month && date.getFullYear() === fullYear) {
          // Valid date
          this.selectedDoc.payment.paymentDate = date;
          this.selectedPaymentDate = `${fullYear}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          this.selectedPaymentDateDisp = `${String(day).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}/${fullYear}`;
        } else {
          // Invalid date, revert to previous value
          if (this.selectedDoc.payment.paymentDate) {
            const prevDate = new Date(this.selectedDoc.payment.paymentDate);
            const prevDay = prevDate.getDate();
            const prevMonth = prevDate.getMonth() + 1;
            const prevYear = prevDate.getFullYear();
            this.selectedPaymentDateDisp = `${String(prevDay).padStart(2, '0')}/${String(prevMonth).padStart(2, '0')}/${prevYear}`;
          } else {
            this.selectedPaymentDateDisp = '';
          }
        }
      } else if (value === '') {
        // Allow clearing the date
        this.selectedPaymentDateDisp = '';
        this.selectedPaymentDate = '';
        this.selectedDoc.payment.paymentDate = null;
      } else {
        // Invalid format, revert to previous value
        if (this.selectedDoc.payment.paymentDate) {
          const prevDate = new Date(this.selectedDoc.payment.paymentDate);
          const prevDay = prevDate.getDate();
          const prevMonth = prevDate.getMonth() + 1;
          const prevYear = prevDate.getFullYear();
          this.selectedPaymentDateDisp = `${String(prevDay).padStart(2, '0')}/${String(prevMonth).padStart(2, '0')}/${prevYear}`;
        } else {
          this.selectedPaymentDateDisp = '';
        }
      }
    },
    ...mapActions({
      fetchPayAcctList: "accountspayable/fetchPayAcctList",
      fetchExpenseList: "accountspayable/fetchExpenseList",
      fetchWhtList: "accountspayable/fetchWhtList",
      fetchVatList: "accountspayable/fetchVatList",
    }),
    buildAccountRecords(invoice) {
      const records = [];
      const recordMap = {};

      const mergeRecord = (rec) => {
        if (!rec.acctCode) return;

        // normalise
        rec.totalDebit  = Number(rec.totalDebit)  || 0;
        rec.totalCredit = Number(rec.totalCredit) || 0;

        if (recordMap[rec.acctCode] !== undefined) {
          const idx = recordMap[rec.acctCode];
          records[idx].totalDebit  += rec.totalDebit;
          records[idx].totalCredit += rec.totalCredit;
          records[idx].isPayment   = records[idx].isPayment || rec.isPayment;
        } else {
          recordMap[rec.acctCode] = records.length;
          records.push({ ...rec });
        }
      };

      // ---------- docLines ----------
      (invoice.docLine || []).forEach((l) => {

        const lineTotal = Number(this.selectedDoc?.totalDisAmount) > 0 ? Number(l.lineTotal) - Number(this.selectedDoc.totalDisAmount) : Number(l.lineTotal) || "";

        // main expense
        mergeRecord({
          acctCode:   l.acctCode  || "",
          acctName:   l.acctName  || "",
          totalDebit:  l.acctType == 0 ? lineTotal : 0,
          totalCredit: l.acctType == 1 ? lineTotal : 0,
        });

        // WHT leg (if any)
        if (l.whtCode) {
          mergeRecord({
            acctCode:   l.whtAcctCode || "",
            acctName:   l.whtAcctName || "",
            totalDebit:  l.acctTypeWht == 0 ? l.whtAmount : 0,
            totalCredit: l.acctTypeWht == 1 ? l.whtAmount : 0,
          });
        }

        // VAT / Tax leg
        mergeRecord({
          acctCode:   l.acctCodeTax || "",
          acctName:   l.acctNameTax || "",
          totalDebit:  l.acctType == 0 ? l.taxAmount : 0,
          totalCredit: l.acctType == 1 ? l.taxAmount : 0,
        });
      });

      // ---------- payment ----------
      if (invoice.payment) {
        const totalPay = Number(
          invoice.payment.paymentTotal ?? 0
        );
        mergeRecord({
          acctCode:   invoice.payment.paymentAcctCode || "",
          acctName:   invoice.payment.paymentAcctName || "",
          totalDebit:  invoice.payment.acctTypePayment == 0 ? totalPay : 0,
          totalCredit: invoice.payment.acctTypePayment == 1 ? totalPay : 0,
          isPayment:  true,
        });
      }

      // ---------- sort buckets ----------
      const debit   = records.filter(r => !r.isPayment && r.totalDebit  > 0)
                            .sort((a,b)=>b.totalDebit  - a.totalDebit);
      const credit  = records.filter(r => !r.isPayment && r.totalCredit > 0)
                            .sort((a,b)=>b.totalCredit - a.totalCredit);
      const payment = records.filter(r =>  r.isPayment)
                            .sort((a,b)=>{
                              const av = a.totalDebit  || a.totalCredit;
                              const bv = b.totalDebit  || b.totalCredit;
                              return bv - av;
                            });

      return [...debit, ...credit, ...payment];
    },

    storeLog({targetPath = "", targetCollectionID = "", targetDocID = "", eventType = '',  eventDetails = {}, eventDesc = "",}) {
      const companyID = this.$route.params.companyId;
      logUserActivity(companyID, this.companyProductType, targetPath, targetCollectionID, targetDocID, eventType, eventDetails, eventDesc);
    },
    storeLogBatch(eventArr = []) {
      const companyID = this.$route.params.companyId;
      logUserActivityBatch(companyID, this.companyProductType, eventArr);
    },
    async setNewDocStatus() {
      try {
        const companyID = this.$route.params.companyId;
      const purchaseInvoicesRef = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoices`)
        .doc(this.selectedDoc.id);
        await purchaseInvoicesRef.set(
        {
          status: "PENDING_APPROVAL",
        },
        { merge: true }
      );
      this.isOpenCustomDialogue = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleEscKey(event) {
      // console.log("event.key::", event.key);
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isOpenCustomDialogue = false;
      }
    },
    sortTable(column) {
      if (this.sortBy === column) {
        // Toggle sort direction if the column is the same
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        // Set the new column and default to ascending order
        this.sortBy = column;
        this.sortDirection = "asc";
      }

      // Save sort state to localStorage
      localStorage.setItem("apSortBy", this.sortBy);
      localStorage.setItem("apSortDirection", this.sortDirection);

      // Perform sorting
      this.purchaseInvoices.sort((a, b) => {
        let result = 0;
        if (a[column] < b[column]) result = -1;
        if (a[column] > b[column]) result = 1;

        // Reverse if the direction is descending
        return this.sortDirection === "asc" ? result : -result;
      });

      // Paginate sorted items
      this.paginate();
    },
    getDocStatus(value) {
      const docStatus = this.docStatusList.find(
        (status) => status.value === value
      );
      return docStatus;
    },
    getStatusTH(status) {
      return this.getDocStatus(status)?.text;
    },
    getColorClass(status) {
      return this.getDocStatus(status)?.colorClass;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbar = {
        isShow: true,
        msg: "คัดลอกเรียบร้อย",
        color: "success",
        icon: "mdi-content-copy",
      };
    },
    isInvalidValue(value) {
      return value === "N/A" || value === 0;
    },
    checkIfInvalid(doclineItem) {
      return (
        this.isInvalidValue(doclineItem.ItemCode) ||
        this.isInvalidValue(doclineItem.ItemName) ||
        this.isInvalidValue(Number(doclineItem.UnitPriceSO)) ||
        this.isInvalidValue(Number(doclineItem.TotalPriceso))
      );
    },
    deleteDocument(doc) {
      this.docToDelete = doc;
      this.dialogDelete = true;
    },
    nAformmater(value) {
      return value === "N/A" ? "" : value;
    },
    debounceInput: _.debounce(function () {
      this.fetchPurchaseInvoices();
    }, 1000),
    formatNum(input) {
      const num = Number(input);

      if (isNaN(num)) {
        console.error("Invalid input:", input);
        return "0.00";
      }

      return num.toFixed(2);
    },
    async openPDFFile() {
      this.isGettingPdfData = true;
       console.log("PDF FILE DOC ID:: ", this.selectedDoc.fileDocRef);
      const companyID = this.$route.params.companyId;

      const purchasePdfFilesRef = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoiceFiles`)
        .doc(this.selectedDoc.fileDocRef);

      try {
        const purchasePdfFileSnapshot = await purchasePdfFilesRef.get();

        if (purchasePdfFileSnapshot.exists) {
          const pdfPathGs = purchasePdfFileSnapshot.data().pdfPath;
           console.log("pdfPathGs:: ", pdfPathGs);

          const callGetPDF = firebase.functions().httpsCallable("callGetPDF");
          const data = { gsPdfPath: pdfPathGs };
          const pdfBase64 = (await callGetPDF(data)).data.httpsPath;

          // Convert Base64 string to Uint8Array
          const byteCharacters = atob(pdfBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Load the PDF document with pdf-lib
          const pdfDoc = await PDFDocument.load(byteArray);

          // Set the PDF title property
          pdfDoc.setTitle(this.selectedDoc?.id);

          // Serialize the PDF document to bytes (Uint8Array)
          const pdfBytes = await pdfDoc.save();

          // Create a new Blob from the modified PDF bytes
          const updatedPdfBlob = new Blob([pdfBytes], {
            type: "application/pdf",
          });

          // Create URL for the updated Blob
          const pdfBlobUrl = URL.createObjectURL(updatedPdfBlob);
          this.pdfUrl = pdfBlobUrl;

          console.log("pdfBlobUrl: ", pdfBlobUrl);
        } else {
          console.log("Document does not exist");
        }
      } catch (error) {
        console.error("Error retrieving PDF file:", error);
      } finally {
        this.isGettingPdfData = false;
      }
    },
    async openImageFile() {
      this.isGettingImageData = true;
      const companyID = this.$route.params.companyId;

      const purchaseInvoiceFileRef = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoiceFiles`)
        .doc(this.selectedDoc.fileDocRef);

      try {
        const purchaseInvoiceFileSnapshot = await purchaseInvoiceFileRef.get();

        if (purchaseInvoiceFileSnapshot.exists) {
          const pdfPathGs = purchaseInvoiceFileSnapshot.data().pdfPath;

          const callGetHttpsFileUrl = firebase
            .functions()
            .httpsCallable("callGetHttpsFileUrl");
          const data = { gsFilePath: pdfPathGs };

          // Get the download URL
          this.imageUrl = (await callGetHttpsFileUrl(data)).data.signedUrl;
        } else {
          console.log("Document does not exist");
        }
      } catch (error) {
        console.error("Error retrieving image file:", error);
      } finally {
        this.isGettingImageData = false;
      }
    },
    openConfirmDialog() {
      this.dialogConfirmDocument = true;
    },
    openConfirmOneDialog() {
      this.dialogConfirmDocumentOne = true;
    },
    openRefreshDocument() {
      this.dialogRefreshDocument = true;
    },
    toggleEditMode() {
      this.dialogConfirmDocumentOne = false;
      this.dialogConfirmDocument = false;
      if (!this.editMode) {
        // Create a deep copy of the selected document
        this.selectedDocCopy = cloneDeep(this.selectedDoc);
      } else {
        // If cancel is clicked, revert back to the deep copy
        if (this.selectedDocCopy) {
          this.selectedDoc = cloneDeep(this.selectedDocCopy);

          // Restore date display values for document date
          if (this.selectedDoc.docDate) {
            let docDate;
            if (this.selectedDoc.docDate instanceof Date) {
              docDate = this.selectedDoc.docDate;
            } else if (this.selectedDoc.docDate.seconds) {
              docDate = new Date(this.selectedDoc.docDate.seconds * 1000);
            } else {
              docDate = new Date(this.selectedDoc.docDate);
            }

            if (!isNaN(docDate.getTime())) {
              const day = docDate.getDate();
              const month = docDate.getMonth() + 1;
              const year = docDate.getFullYear();
              this.PiDateDisp = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
              this.selectedPiDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            } else {
              this.PiDateDisp = '';
              this.selectedPiDate = '';
            }
          } else {
            this.PiDateDisp = '';
            this.selectedPiDate = '';
          }

          // Restore date display values for due date
          if (this.selectedDoc.docDueDate && this.selectedDoc.docDueDate !== 'Invalid Date' && this.selectedDoc.docDueDate !== '') {
            let dueDate;
            if (this.selectedDoc.docDueDate instanceof Date) {
              dueDate = this.selectedDoc.docDueDate;
            } else if (this.selectedDoc.docDueDate.seconds) {
              // Firebase Timestamp
              dueDate = new Date(this.selectedDoc.docDueDate.seconds * 1000);
            } else if (typeof this.selectedDoc.docDueDate === 'string' && this.selectedDoc.docDueDate !== '') {
              dueDate = new Date(this.selectedDoc.docDueDate);
            }

            if (dueDate && !isNaN(dueDate.getTime())) {
              const day = dueDate.getDate();
              const month = dueDate.getMonth() + 1;
              const year = dueDate.getFullYear();
              this.PiDueDateDisp = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
              this.selectedPiDueDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            } else {
              this.PiDueDateDisp = '';
              this.selectedPiDueDate = '';
            }
          } else {
            this.PiDueDateDisp = '';
            this.selectedPiDueDate = '';
          }

          // Restore date display values for payment date
          if (this.selectedDoc.payment && this.selectedDoc.payment.paymentDate && this.selectedDoc.payment.paymentDate !== 'Invalid Date') {
            let paymentDate;
            if (this.selectedDoc.payment.paymentDate instanceof Date) {
              paymentDate = this.selectedDoc.payment.paymentDate;
            } else if (this.selectedDoc.payment.paymentDate.seconds) {
              paymentDate = new Date(this.selectedDoc.payment.paymentDate.seconds * 1000);
            } else {
              paymentDate = new Date(this.selectedDoc.payment.paymentDate);
            }

            if (!isNaN(paymentDate.getTime())) {
              const day = paymentDate.getDate();
              const month = paymentDate.getMonth() + 1;
              const year = paymentDate.getFullYear();
              this.selectedPaymentDateDisp = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
              this.selectedPaymentDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            } else {
              this.selectedPaymentDateDisp = '';
              this.selectedPaymentDate = '';
            }
          } else {
            this.selectedPaymentDateDisp = '';
            this.selectedPaymentDate = '';
          }
        }
        
        this.selectedDocCopy = null; // Clear the temporary copy
      }
      this.editMode = !this.editMode;
    },
    copyExternalDocId() {
      try {
        navigator.clipboard.writeText(this.selectedDoc.id);
        this.snackbar = {
          isShow: true,
          msg: "คัดลอกเรียบร้อย",
          icon: "mdi-content-copy",
          color: "success",
        };
      } catch (error) {
        console.error("Error copying external document ID:", error);
      }
    },
    openExternalFirebaseLink() {
      try {
        const hrefLink = `https://console.firebase.google.com/project/sld-etax/firestore/databases/-default-/data/~2FCompanies~2F${this.$route.params.companyId}~2FPurchaseInvoices~2F${this.selectedDoc.id}`;
        window.open(hrefLink, "_blank");
      } catch (error) {
        console.error("Error opening external Firebase link:", error);
      }
    },
    downloadExtractedText(apID) {
      console.log("apID", apID);

      fc.db
        .collection(
          `Companies/${this.companyId}/PurchaseInvoices/${apID}/ProcessLogs`
        )
        .orderBy("@timeCreate", "desc")
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            console.log(
              "No extracted text found for Purchase Invoice ID",
              apID
            );

            this.snackbar = {
              isShow: true,
              msg: "ไม่พบข้อมูล",
              color: "error",
            };
            return;
          }

          const resData = snap.docs[0].data();
          // Choose the appropriate field based on your data structure

          const textContent = resData.invoiceText || "";

          if (!textContent) {
            console.log("No text content available to download.");
            return;
          }

          // Prepare the text content
          let fileContent = "";
          if (Array.isArray(textContent)) {
            fileContent = textContent.join("\n");
          } else if (typeof textContent === "string") {
            fileContent = textContent;
          } else {
            fileContent = JSON.stringify(textContent, null, 2);
          }

          // Create a Blob from the text content
          const blob = new Blob([fileContent], { type: "text/plain" });
          const url = URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `AP-TXT-${apID}.txt`;
          document.body.appendChild(a);
          a.click();

          // Clean up the temporary elements and revoke the object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          console.log("Download initiated for apID", apID);
        })
        .catch((err) => {
          console.error("Error fetching extracted text:", err);
        });
    },
    downloadJson(apID) {
      console.log("apID", apID);

      fc.db
        .collection(
          `Companies/${this.companyId}/PurchaseInvoices/${apID}/ProcessLogs`
        )
        .orderBy("@timeCreate", "desc")
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            console.log("No JSON found for Purchase Invoice ID", apID);
            this.snackbar = {
              isShow: true,
              msg: "ไม่พบข้อมูล",
              color: "error",
            };
            return;
          }

          const jsonData = snap.docs[0].data();
          // Adjust the field name based on your Firestore document structure
          let jsonOutput = "";
          
          if (jsonData.aiResponse) {
            // New format with aiResponse field
            const aiResponseData = JSON.parse(jsonData.aiResponse);
            if (aiResponseData.provider === 'OpenAI' && aiResponseData.choices) {
              jsonOutput = aiResponseData.choices[0]?.message?.content;
            } else if (aiResponseData.provider === 'Google' && aiResponseData.content) {
              jsonOutput = aiResponseData.content;
            }
          } else if (jsonData.gptResponse) {
            // Legacy format with gptResponse field
            jsonOutput = JSON.parse(jsonData.gptResponse)?.choices[0]?.message?.content;
          }

          if (!jsonOutput) {
            console.log("No JSON content available to download.");
            return;
          }

          let fileContent = "";

          if (typeof jsonOutput === "object") {
            // If it's already an object, stringify it
            fileContent = JSON.stringify(jsonOutput, null, 2);
          } else if (typeof jsonOutput === "string") {
            try {
              // If it's a string, try parsing and then stringifying for formatting
              const parsed = JSON.parse(jsonOutput);
              fileContent = JSON.stringify(parsed, null, 2);
            } catch (e) {
              // If parsing fails, use the string as-is
              fileContent = jsonOutput;
            }
          } else {
            // For other data types, convert to JSON string
            fileContent = JSON.stringify(jsonOutput, null, 2);
          }

          // Create a Blob from the JSON content
          const blob = new Blob([fileContent], { type: "application/json" });
          const url = URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `AP-JSON-${apID}.json`; // Updated filename with .json extension
          document.body.appendChild(a);
          a.click();

          // Clean up the temporary elements and revoke the object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          console.log("Download initiated for apID", apID);
        })
        .catch((err) => {
          console.error("Error fetching JSON data:", err);
        });
    },
    downloadPdf() {
      if (!this.pdfUrl) {
        this.snackbar = {
          isShow: true,
          msg: "ไม่พบไฟล์ PDF",
          color: "error",
        };
        return;
      }

      try {
        // Create a temporary anchor element to trigger the download
        const a = document.createElement("a");
        a.href = this.pdfUrl;
        a.download = `AP-PDF-${this.selectedDoc?.docId || this.selectedDoc?.id}.pdf`;
        document.body.appendChild(a);
        a.click();

        // Clean up the temporary element
        document.body.removeChild(a);

        this.snackbar = {
          isShow: true,
          msg: "ดาวน์โหลด PDF เรียบร้อย",
          color: "success",
        };

        console.log("PDF download initiated for document:", this.selectedDoc?.id);
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการดาวน์โหลด PDF",
          color: "error",
        };
      }
    },
    async refreshPurchasePdfFile() {
      this.isRefreshingDoc = true;
      try {
        const companyID = this.$route.params.companyId;
        const purchaseInvoiceFilesRef = fc.db
          .collection(`Companies/${companyID}/PurchaseInvoiceFiles`)
          .doc(this.selectedDoc.fileDocRef);

        const purchaseInvoiceRef = fc.db
          .collection(`Companies/${companyID}/PurchaseInvoices`)
          .doc(this.selectedDoc.id);
        // await purchaseInvoiceRef.set(
        //   {
        //     status: "FETCHING",
        //   },
        //   { merge: true }
        // );

        await purchaseInvoiceRef.delete();

        // console.log("setFetchStatus Success");

        await fc.db.runTransaction(async (transaction) => {
          const docSnapshot = await transaction.get(purchaseInvoiceFilesRef);
          let refreshValue = docSnapshot.data().refresh || 0; // Get current 'refresh' value or default to 0
          refreshValue++;
          transaction.update(purchaseInvoiceFilesRef, {
            refresh: refreshValue,
          });
        });
        this.isRefreshingDoc = false;

        //  console.log('Refreshed the Purchase PDF File.');
      } catch (error) {
        console.error("Error updating the refresh field:", error);
        this.isRefreshingDoc = false;
      } finally {
        this.isOpenCustomDialogue = false;
        this.selectedDoc = {};
      }
    },

    exitEditMode() {
      // Clear the temporary copy and exit edit mode
      this.selectedDocCopy = null;
      this.editMode = false;
    },
    async updateDocument() {
      try {
        // Validate that docDate is not empty
        if (!this.selectedDoc.docDate || !this.PiDateDisp) {
          this.snackbar = {
            isShow: true,
            msg: "กรุณาระบุวันที่เอกสาร",
            color: "error",
          };
          return;
        }

        // Set updating to true to indicate update in progress
        this.isUpdating = true;

        let user = firebase.auth().currentUser;

        const companyID = this.$route.params.companyId;

        const docsRef = fc.db
          .collection(`Companies/${companyID}/PurchaseInvoices`)

        const isDuplicateDocId = await docsRef.where("docId", "==", this.selectedDoc.docId).where("id", "!=", this.selectedDoc.id).get();

        if(isDuplicateDocId.size > 0) {
          this.snackbar = {
            isShow: true,
            msg: "เลขที่เอกสารซ้ํา",
            color: "warning",
          };
          return;
        }          

             // totalBeforeDiscount
        // totalBeforeVat
        // totalDisAmount
        // totalTaxAmount
        // totalWhtAmount
        // Update the document in Firebase with new values

        // Prepare update data for Firebase without modifying the original selectedDoc
        const updateData = {
          ...this.selectedDoc,
          payment: {
            ...this.selectedDoc.payment,
            paymentTotal: this.docTotalPayment,
          },
          // docTaxRefNo: this.selectedDoc.docId,
          totalBeforeDiscount: this.docTotalBeforeDis,
          totalBeforeVat: this.docTotalBeforeDis,
          docTotal: this.docTotalPayment,
          totalTaxAmount: this.docTaxAmount,
          totalWhtAmount: String(this.docWhtAmount),
          status: INVOICE_STATUS.PENDING_APPROVAL,
          timeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
          timeLastUpdateBy: user.uid,
          isDuplicate: false,
          '@APTRAN_STATUS': '',
          docTaxPeriod: this.selectedDoc.docTaxPeriod || "",
        };

        // Handle docDate - ensure it's a valid Date object (required field)
        if (this.selectedDoc.docDate) {
          if (this.selectedDoc.docDate instanceof Date) {
            // Validate that the Date object is valid
            if (!isNaN(this.selectedDoc.docDate.getTime())) {
              updateData.docDate = this.selectedDoc.docDate;
            } else {
              console.error('Invalid docDate Date object detected:', this.selectedDoc.docDate);
              this.snackbar = {
                isShow: true,
                msg: "วันที่เอกสารไม่ถูกต้อง",
                color: "error",
              };
              return;
            }
          } else if (this.selectedDoc.docDate.seconds) {
            // Firebase Timestamp - convert to Date
            updateData.docDate = new Date(this.selectedDoc.docDate.seconds * 1000);
          } else if (typeof this.selectedDoc.docDate === 'string' && this.selectedDoc.docDate !== '') {
            // String date - convert to Date and validate
            const newDate = new Date(this.selectedDoc.docDate);
            if (!isNaN(newDate.getTime())) {
              updateData.docDate = newDate;
            } else {
              console.error('Invalid docDate string detected:', this.selectedDoc.docDate);
              this.snackbar = {
                isShow: true,
                msg: "วันที่เอกสารไม่ถูกต้อง",
                color: "error",
              };
              return;
            }
          }
        }

        // Handle docDueDate - can be empty string, Date object, or null (optional field)
        if (this.selectedDoc.docDueDate && this.selectedDoc.docDueDate !== '' && this.selectedDoc.docDueDate !== 'Invalid Date') {
          if (this.selectedDoc.docDueDate instanceof Date) {
            // Validate that the Date object is valid
            if (!isNaN(this.selectedDoc.docDueDate.getTime())) {
              updateData.docDueDate = this.selectedDoc.docDueDate;
            } else {
              updateData.docDueDate = '';
            }
          } else if (this.selectedDoc.docDueDate.seconds) {
            // Firebase Timestamp - convert to Date
            updateData.docDueDate = new Date(this.selectedDoc.docDueDate.seconds * 1000);
          } else if (typeof this.selectedDoc.docDueDate === 'string' && this.selectedDoc.docDueDate !== '') {
            // String date - convert to Date and validate
            const newDate = new Date(this.selectedDoc.docDueDate);
            if (!isNaN(newDate.getTime())) {
              updateData.docDueDate = newDate;
            } else {
              updateData.docDueDate = '';
            }
          }
        } else {
          // Save as empty string when no date is provided
          updateData.docDueDate = '';
        }

        // Handle payment date - ensure it's a valid Date object (required field)
        if (this.selectedDoc.payment && this.selectedDoc.payment.paymentDate) {
          if (this.selectedDoc.payment.paymentDate instanceof Date) {
            // Validate that the Date object is valid
            if (!isNaN(this.selectedDoc.payment.paymentDate.getTime())) {
              updateData.payment.paymentDate = this.selectedDoc.payment.paymentDate;
            } else {
              console.error('Invalid paymentDate Date object detected:', this.selectedDoc.payment.paymentDate);
              this.snackbar = {
                isShow: true,
                msg: "วันที่จ่ายชำระไม่ถูกต้อง",
                color: "error",
              };
              return;
            }
          } else if (this.selectedDoc.payment.paymentDate.seconds) {
            // Firebase Timestamp - convert to Date
            updateData.payment.paymentDate = new Date(this.selectedDoc.payment.paymentDate.seconds * 1000);
          } else if (typeof this.selectedDoc.payment.paymentDate === 'string' && this.selectedDoc.payment.paymentDate !== '') {
            // String date - convert to Date and validate
            const newDate = new Date(this.selectedDoc.payment.paymentDate);
            if (!isNaN(newDate.getTime())) {
              updateData.payment.paymentDate = newDate;
            } else {
              console.error('Invalid paymentDate string detected:', this.selectedDoc.payment.paymentDate);
              this.snackbar = {
                isShow: true,
                msg: "วันที่จ่ายชำระไม่ถูกต้อง",
                color: "error",
              };
              return;
            }
          }
        }

        const accountDiff = Math.abs(
          Number(this.totalAccountRecordDebit) - Number(this.totalAccountRecordCredit)
        );
        if (accountDiff >= 0.01) {
          updateData.status = INVOICE_STATUS.WARNING;
          updateData.failureMessage = "ยอดรวมคู่บัญชีไม่ตรงกัน";
        }

            // Define fields to ignore in the diff
         // Compute the diff using the recursive function
         const diff = this.getDeepDiff(this.selectedDocCopy, updateData);
        //  console.log("diff::", diff);

        const targetPath = `Companies/${companyID}/PurchaseInvoices/${this.selectedDoc.id}`;
        updateData.isEdited = true;

        // Create a copy for Firestore that excludes id and timeCreate
        const firestoreData = { ...updateData };
        delete firestoreData.id;
        delete firestoreData.timeCreate;

        const docRef = fc.db.doc(targetPath);
        await docRef.set(firestoreData, { merge: true });
        // Update successful
        console.log("Document updated successfully!");
        this.exitEditMode();
        this.snackbar = {
          isShow: true,
          msg: "บันทึกเอกสารเรียบร้อย",
          color: "success",
        };

        this.storeLog(
          {
            targetPath: targetPath,
            targetCollectionID: "PurchaseInvoices",
            targetDocID: updateData.id,
            eventType: EVENT_TYPES.UPDATE,
            eventDetails: diff,
            eventDesc: "Update document",
          }
        )
        // Exit edit mode
      } catch (error) {
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการบันทึกเอกสาร",
          color: "error",
        };

        console.error("Error updating document: ", error);
      } finally {
        // Set updating to false regardless of success or failure
        this.editMode = false;
        this.isUpdating = false;
        // this.isOpenCustomDialogue = false;
      }
    },
    async confirmDocument() {
  const uid = firebase.auth().currentUser.uid;
  const companyID = this.$route.params.companyId;

  // Filter the purchase invoices eligible for confirmation
  const docsToConfirm = this.purchaseInvoices.filter(
    (po) =>
      this.selectedItems.includes(po.id) &&
      po.status === INVOICE_STATUS.PENDING_APPROVAL
  );

  if (docsToConfirm.length === 0) {
    console.log("No documents are eligible for confirmation.");
    return;
  }

  // Create a Firestore batch
  const batch = fc.db.batch();

  // this.storeLog(
  //         {
  //           targetPath: targetPath,
  //           targetDocID: id,
  //           eventType: EVENT_TYPES.DELETE,
  //           eventDetails: {},
  //           eventDesc: "Delete document",
  //         }
  //       );

  const logArr = []

  docsToConfirm.forEach((selectedDoc) => {
    const docRef = fc.db
      .collection(`Companies/${companyID}/PurchaseInvoices`)
      .doc(selectedDoc.id);
    batch.set(
      docRef,
      {
        status: INVOICE_STATUS.POSTING,
        owner: uid,
        ownerData: this.user,
        timeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
      },
      { merge: true }
    );

    logArr.push({
      targetPath: `Companies/${companyID}/PurchaseInvoices/${selectedDoc.id}`,
      targetCollectionID: "PurchaseInvoices",
      targetDocID: selectedDoc.id,
      eventType: EVENT_TYPES.APPROVE,
      eventDetails: {},
      eventDesc: "Confirm document",
    })

  });

  try {
    // Commit the entire batch
    await batch.commit();
    console.log(
      "All documents confirmed successfully:",
      docsToConfirm.map((doc) => doc.id)
    );

    this.storeLogBatch(logArr)

  } catch (error) {
    console.error("Error confirming documents:", error);
  } finally {
    // Reset UI state after updating
    this.selectedItems = [];
    this.dialogConfirmDocument = false;
    this.selectAll = false;
    this.isOpenCustomDialogue = false;
  }

  // Refresh the list to reflect the changes
  this.fetchPurchaseInvoices();
},
    async confirmDocumentOne() {
      this.isConfirmingDoc = true;
      const companyID = this.$route.params.companyId;

      // If there are no documents to confirm, return early

      // Iterate over each document eligible for confirmation
      const targetPath = `Companies/${companyID}/PurchaseInvoices/${this.selectedDoc.id}`;
      const purchaseOrdersRef = fc.db.doc(targetPath);

      const uid = firebase.auth().currentUser.uid;

      try {
        // Update the status of the current document to "CONFIRMED"
        await purchaseOrdersRef.set(
          {
            status: INVOICE_STATUS.POSTING,
            owner: uid,
            ownerData: this.user,
            timeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
        console.log(
          `Document with id ${this.selectedDoc.id} confirmed successfully.`
        );

        this.snackbar = {
          isShow: true,
          msg: "ยืนยันเอกสารเรียบร้อยแล้ว",
          color: "success",
        };

        this.storeLog(
          {
            targetPath: targetPath,
            targetCollectionID: "PurchaseInvoices",
            targetDocID: this.selectedDoc.id,
            eventType: EVENT_TYPES.APPROVE,
            eventDetails: {},
            eventDesc: "Approve document",
          }
        )

      } catch (error) {
        console.error(
          `Error confirming document with id ${this.selectedDoc.id}:`,
          error
        );

        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการยืนยันเอกสาร",
          color: "error",
        };

      } finally {
        this.selectedDoc = {};
        this.dialogConfirmDocumentOne = false;
        this.isOpenCustomDialogue = false;
        this.isConfirmingDoc = false;
      }

      // Fetch purchase orders to reflect the changes
      this.fetchPurchaseInvoices();

      // Close the confirmation dialog
      this.isOpenCustomDialogue = false;
    },
    async fetchPurchaseInvoices() {
      if (this.aiSearchEnabled) {
        await this.fetchPurchaseInvoicesAi();
        return;
      }
      await this.fetchPurchaseInvoicesDefault();
    },
    async handleAiSearchToggle() {
      const query = this.searchDocID?.trim();
      console.log(
        "AI search toggle changed:",
        this.aiSearchEnabled ? "ON" : "OFF",
        "query:",
        query
      );

      if (this.aiSearchEnabled) {
        await this.fetchPurchaseInvoicesAi();
      } else {
        this.aiSearchResults = [];
        await this.fetchPurchaseInvoicesDefault();
      }
    },
    async fetchPurchaseInvoicesAi() {
      this.isLoadingDocs = true;
      this.purchaseInvoices = [];
      this.displayedItems = [];
      this.totalItems = 0;
      this.currentPage = 1;
      try {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
        const companyID = this.$route.params.companyId;
        const query = this.searchDocID?.trim();

        if (!query) {
          this.purchaseInvoices = [];
          this.displayedItems = [];
          this.totalItems = 0;
          this.currentPage = 1;
          this.isLoadingDocs = false;
          return;
        }

        const callSearchPurchaseInvoices = firebase
          .functions()
          .httpsCallable("callSearchPurchaseInvoices");

        const response = await callSearchPurchaseInvoices({
          query,
          companyId: companyID,
          pageSize: this.itemsPerPage,
        });

        const { results = [], totalSize = 0 } = response.data || {};
        console.log(
          "AI search response (JSON):",
          JSON.stringify(response.data || {}, null, 2)
        );

        this.aiSearchResults = (results || [])
          .map((result) => this.normalizeAiResult(result))
          .filter((result) => DEFAULT_STATUS_LIST.includes(result.status));
        
        console.log(
          "AI search normalized results (after status filter):",
          JSON.stringify(this.aiSearchResults, null, 2)
        );

        this.purchaseInvoices = this.aiSearchResults;
        this.totalItems = this.purchaseInvoices.length;
        this.currentPage = 1;
        // this.applySavedSortState();
        // ไม่ต้องเรียงลำดับใหม่ ให้ใช้ลำดับที่ AI ตอบกลับมา
        this.displayedItems = this.purchaseInvoices;
      } catch (error) {
        console.error("Error fetching AI search results:", error);
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการค้นหาด้วย AI",
          color: "error",
        };
        this.purchaseInvoices = [];
        this.displayedItems = [];
        this.totalItems = 0;
        this.currentPage = 1;
      } finally {
        this.isLoadingDocs = false;
      }
    },
    async fetchPurchaseInvoicesDefault() {
      this.aiSearchResults = [];
      this.isLoadingDocs = true;
      try {
        const { searchDocID, searchStatus, searchStartDate, searchEndDate } =
          this;

        const companyID = this.$route.params.companyId;

        let query = fc.db.collection(`Companies/${companyID}/PurchaseInvoices`);

        const orderByFields = [];

        if (searchDocID) {
          query = query.where("docId", "==", searchDocID);
          orderByFields.push("docId");
        }

        // Use custom date range if specified
        if (searchStartDate) {
          const start = new Date(searchStartDate);
          start.setHours(0);

          const end = searchEndDate
            ? new Date(searchEndDate)
            : new Date(searchStartDate);
          end.setHours(23, 59, 59, 999);

          query = query.where("docDate", ">=", start);
          query = query.where("docDate", "<=", end);
        }
        orderByFields.unshift("docDate");

        // Filter out foreign vendors
        query = query.where("isForeign", "==", false);
        orderByFields.push("isForeign");

        // Status filter - SUCCESS only
        query = query.where("status", "==", INVOICE_STATUS.SUCCESS);
        orderByFields.push("status");

        orderByFields.forEach((field) => {
          query = query.orderBy(field, field === "docDate" ? "desc" : "asc");
        });

        if (this.unsubscribe) {
          this.unsubscribe();
        }
        this.unsubscribe = query.onSnapshot((snapshot) => {
          let docs = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          if (this.isSourceFilterEnabled) {
            if (this.searchSource === "MANUAL") {
              docs = docs.filter((doc) => doc.isManualCreate === true);
            } else if (this.searchSource === "AI") {
              docs = docs.filter((doc) => !doc.isManualCreate);
            }
          }
          this.purchaseInvoices = docs;
          this.totalItems = this.purchaseInvoices.length;
          if (this.totalItems === 0) {
            this.displayedItems = [];
            this.currentPage = 1;
          } else {
            this.applySavedSortState();
          }
          this.isLoadingDocs = false;
        });
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
        this.isLoadingDocs = false;
        this.purchaseInvoices = [];
        this.displayedItems = [];
        this.totalItems = 0;
        this.currentPage = 1;
      }
    },
    normalizeAiResult(result) {
      const rawData = this.extractDiscoveryDocument(result);

      const base = {
        ...rawData,
        id: rawData?.id || result.id,
        docId: rawData?.docId || rawData?.docTaxRefNo || result.docId,
        companyId: rawData?.companyId || result.companyId,
      };

      const docDate = this.normalizeAiDate(base.docDate);
      const docDueDate = this.normalizeAiDate(base.docDueDate);
      const paymentDate = this.normalizeAiDate(base.payment?.paymentDate);

      return {
        ...base,
        docDate,
        docDueDate,
        payment: {
          ...base.payment,
          paymentDate,
        },
        totalBeforeDiscount: this.toNumber(
          base.totalBeforeDiscount ?? base.totalBeforeVat
        ),
        totalTaxAmount: this.toNumber(
          base.totalTaxAmount ?? base.totalTaxAmountVat
        ),
        docTotal: this.toNumber(
          base.docTotal ?? base.totalNetAmount ?? base.amount
        ),
      };
    },
    normalizeAiDate(field) {
      if (!field) return null;

      if (field._seconds || field._nanoseconds) {
        return new Date((field._seconds || 0) * 1000);
      }

      if (field.seconds) {
        return new Date(field.seconds * 1000);
      }

      if (typeof field === "string" || typeof field === "number") {
        const parsed = new Date(field);
        return isNaN(parsed.getTime()) ? null : parsed;
      }

      if (field.fields && field.fields._seconds) {
        return new Date(field.fields._seconds.numberValue * 1000);
      }

      return null;
    },
    extractDiscoveryDocument(result) {
      if (!result) return {};

      if (result.document?.structData) {
        return result.document.structData;
      }

      if (result.document?.fields) {
        return this.convertDiscoveryFields(result.document.fields);
      }

      if (result.structData) {
        return result.structData;
      }

      if (result.fields) {
        return this.convertDiscoveryFields(result.fields);
      }

      return result;
    },
    convertDiscoveryFields(fields = {}) {
      const parsed = {};
      Object.entries(fields).forEach(([key, value]) => {
        parsed[key] = this.extractDiscoveryFieldValue(value);
      });
      return parsed;
    },
    extractDiscoveryFieldValue(field) {
      if (field == null) {
        return null;
      }

      if (typeof field !== "object") {
        return field;
      }

      if (Object.prototype.hasOwnProperty.call(field, "stringValue")) {
        return field.stringValue;
      }

      if (Object.prototype.hasOwnProperty.call(field, "numberValue")) {
        return Number(field.numberValue);
      }

      if (Object.prototype.hasOwnProperty.call(field, "boolValue")) {
        return Boolean(field.boolValue);
      }

      if (Object.prototype.hasOwnProperty.call(field, "nullValue")) {
        return null;
      }

      if (field.listValue || field.values) {
        const values = field.listValue?.values || field.values || [];
        return values.map((item) => this.extractDiscoveryFieldValue(item));
      }

      if (field.structValue || field.fields) {
        const structFields = field.structValue?.fields || field.fields || {};
        return this.convertDiscoveryFields(structFields);
      }

      return field;
    },
    toNumber(value) {
      if (value == null) return 0;

      if (typeof value === "string") {
        const cleaned = value.replace(/,/g, "").trim();
        const parsed = Number(cleaned);
        return Number.isFinite(parsed) ? parsed : 0;
      }

      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      return 0;
    },
    applySavedSortState() {
      // Apply the saved sort state to the current data
      if (this.purchaseInvoices.length > 0) {
        this.purchaseInvoices.sort((a, b) => {
          let result = 0;
          if (a[this.sortBy] < b[this.sortBy]) result = -1;
          if (a[this.sortBy] > b[this.sortBy]) result = 1;

          // Reverse if the direction is descending
          return this.sortDirection === "asc" ? result : -result;
        });
        
        // Update pagination after sorting
        this.paginate();
      }
    },
    paginate() {
      const totalPages = this.numPages;
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages || 1; // Set to last page or 1 if no items
      }
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      this.displayedItems = this.purchaseInvoices.slice(startIndex, endIndex);

      // Clear selection
      this.selectedItems = [];
      this.selectAll = false;
    },
    toggleAll() {
      if (this.selectAll) {
        this.selectedItems = this.displayedItems.map((item) => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    getCheckboxValue(item) {
      return `${item.id}`;
    },
    handleStatusSearch() {
      this.fetchPurchaseInvoices(this.searchKeywords);
      // console.log("Search status", this.searchKeywords);
    },
    confirmDelete() {
      this.dialogDelete = true;
    },
    async deleteSelectedItems() {
      // Delete selected items by their POIDs
      // console.log("this.docToDelete:: ", this.docToDelete.id);
      const id = this.docToDelete.id;
      try {
        const companyID = this.$route.params.companyId;
        const targetPath = `Companies/${companyID}/PurchaseInvoices/${id}`;
        await fc.db
          .doc(targetPath)
          .set(
            {
              status: "DELETED",
            },
            { merge: true }
          );


          this.storeLog(
          {
            targetPath: targetPath,
            targetCollectionID: "PurchaseInvoices",
            targetDocID: id,
            eventType: EVENT_TYPES.DELETE,
            eventDetails: {},
            eventDesc: "Delete document",
          }
        )

      } catch (error) {
        console.error(`Error deleting item with id ${id}:`, error);
      }
      // After deletion, clear selected items
      // No need to refetch data, as it updates in real-time
      // Close the confirmation dialog
      this.dialogDelete = false;
    },
    // Method to show Docline details dialog
    async showDocDetailDialog(doc) {
      // Reset edit mode and copy when opening dialog
      this.editMode = false;
      this.selectedDocCopy = null;

      // ถ้าเป็นผลการค้นหา AI ให้ get document จริงๆ จาก Firestore
      if (this.aiSearchEnabled && this.aiSearchResults.length > 0) {
        try {
          const companyID = this.$route.params.companyId;
          const docRef = fc.db.collection(`Companies/${companyID}/PurchaseInvoices`).doc(doc.id);
          const docSnap = await docRef.get();
          
          if (docSnap.exists) {
            this.selectedDoc = cloneDeep(docSnap.data());
            this.selectedDoc.id = docSnap.id;
          } else {
            this.selectedDoc = cloneDeep(doc);
          }
        } catch (error) {
          console.error('Error fetching document from Firestore:', error);
          this.selectedDoc = cloneDeep(doc);
        }
      } else {
        this.selectedDoc = cloneDeep(doc);
      }
      
      this.selectedDocIdCopy = this.selectedDoc.docId;

      // Initialize date display values for document date
      if (doc.docDate) {
        let docDate;
        if (doc.docDate instanceof Date) {
          docDate = doc.docDate;
        } else if (doc.docDate.seconds) {
          // Firebase Timestamp
          docDate = new Date(doc.docDate.seconds * 1000);
        } else {
          docDate = new Date(doc.docDate);
        }

        if (!isNaN(docDate.getTime())) {
          const day = docDate.getDate();
          const month = docDate.getMonth() + 1;
          const year = docDate.getFullYear();
          this.PiDateDisp = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
          this.selectedPiDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        } else {
          this.PiDateDisp = '';
          this.selectedPiDate = '';
        }
      } else {
        this.PiDateDisp = '';
        this.selectedPiDate = '';
      }

      // Initialize date display values for due date
      if (doc.docDueDate && doc.docDueDate !== 'Invalid Date' && doc.docDueDate !== '') {
        let dueDate;
        if (doc.docDueDate instanceof Date) {
          dueDate = doc.docDueDate;
        } else if (doc.docDueDate.seconds) {
          // Firebase Timestamp
          dueDate = new Date(doc.docDueDate.seconds * 1000);
        } else if (typeof doc.docDueDate === 'string' && doc.docDueDate !== '') {
          dueDate = new Date(doc.docDueDate);
        }

        if (dueDate && !isNaN(dueDate.getTime())) {
          const day = dueDate.getDate();
          const month = dueDate.getMonth() + 1;
          const year = dueDate.getFullYear();
          this.PiDueDateDisp = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
          this.selectedPiDueDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        } else {
          this.PiDueDateDisp = '';
          this.selectedPiDueDate = '';
        }
      } else {
        this.PiDueDateDisp = '';
        this.selectedPiDueDate = '';
      }

      // Initialize date display values for payment date
      if (doc.payment && doc.payment.paymentDate && doc.payment.paymentDate !== 'Invalid Date') {
        let paymentDate;
        if (doc.payment.paymentDate instanceof Date) {
          paymentDate = doc.payment.paymentDate;
        } else if (doc.payment.paymentDate.seconds) {
          // Firebase Timestamp
          paymentDate = new Date(doc.payment.paymentDate.seconds * 1000);
        } else {
          paymentDate = new Date(doc.payment.paymentDate);
        }

        if (!isNaN(paymentDate.getTime())) {
          const day = paymentDate.getDate();
          const month = paymentDate.getMonth() + 1;
          const year = paymentDate.getFullYear();
          this.selectedPaymentDateDisp = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
          this.selectedPaymentDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        } else {
          this.selectedPaymentDateDisp = '';
          this.selectedPaymentDate = '';
        }
      } else {
        this.selectedPaymentDateDisp = '';
        this.selectedPaymentDate = '';
      }

      // Initialize tax period list
      this.taxPeriodList = this.generateTaxPeriodList();

      // Open dialog and load file
      this.isOpenCustomDialogue = true;
    },
    resetSearchConfig() {
      this.searchDocID = "";
      this.searchStatus = INVOICE_STATUS.SUCCESS;
      this.searchSource = "SHOW_ALL";
      this.searchStartDate = null;
      this.searchEndDate = null;
    },
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";

      let date;

      if (timestamp instanceof Date) {
        date = timestamp;
      } else if (timestamp.seconds) {
        date = new Date(timestamp.seconds * 1000);
      } else if (timestamp._seconds) {
        date = new Date(timestamp._seconds * 1000);
      } else {
        date = new Date(timestamp);
      }

      if (!(date instanceof Date) || isNaN(date.getTime())) {
        return "N/A";
      }

      moment.locale("th");
      return moment(date).add(543, "years").format("DD MMM YY");
    },
    async fetchPurchaseInvoicesByDateRange(fromDate, toDate) {
      console.log("fromDate::", fromDate);
      console.log("toDate::", toDate);
      this.searchStartDate = fromDate;
      this.searchEndDate = toDate;
      await this.fetchPurchaseInvoices();
    },
    resetDateSearch() {
      this.resetSearchConfig();
      this.fetchPurchaseInvoices();
    },
    cancelExportDocs() {
      this.exportDialog = false;
      // this.$refs.form.reset();
      this.dateExportEnd = "";
      this.dateExportStart = "";
    },
    async exportDocs() {
      if (!this.dateExportStart) {
        this.snackbar = {
          isShow: true,
          msg: "กรุณาเลือกวันที่เริ่มต้น",
          color: "error",
        };
        return;
      }
      if (!this.dateExportEnd) {
        this.snackbar = {
          isShow: true,
          msg: "กรุณาเลือกวันที่สิ้นสุด",
          color: "error",
        };
        return;
      }

      const startDate = new Date(this.dateExportStart);
      startDate.setHours(0);
      const endDate = new Date(this.dateExportEnd);
      endDate.setHours(23, 59, 59, 999);

      if (startDate > endDate) {
        this.snackbar = {
          isShow: true,
          msg: "วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด",
          color: "error",
        };

        return;
      }

      let query = fc.db.collection(
        `Companies/${this.companyId}/PurchaseInvoices`
      );
      // Always query SUCCESS status for export
      query = query.where("status", "==", INVOICE_STATUS.SUCCESS);
      if (this.vendorId) {
        query = query.where("CompanyCode", "==", this.vendorId);
      }
      query = query
        .where("docDate", ">=", startDate)
        .where("docDate", "<=", endDate);
      // Filter out foreign vendors
      query = query.where("isForeign", "==", false);

      const exportData = [];
      await query.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const temp = doc.data();
          delete temp.Docline;
          exportData.push(temp);
        });
      });

      if (exportData.length === 0) {
        this.snackbar = {
          isShow: true,
          msg: "ไม่พบข้อมูลที่ต้องการส่งออก กรุณาเลือกระยะเวลาใหม่",
          color: "error",
        };

        return;
      }
      const header = Object.keys(exportData[0]);

      console.log("exportData:: ", exportData);

      const worksheet = XLSX.utils.json_to_sheet(exportData, {
        header: header,
      });

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "PurchaseInvoices");

      const fileName = `PurchaseOrders_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    },
    intPage() {
      this.vendorId = this.$route.params?.vendorId || "";
      this.companyId = this.$route.params?.companyId || "";

      this.$store.dispatch("companies/getCompanyProductList", {
        companyId: this.companyId,
      });
    },
    formattedText(item) {
      return `${item.paymentCode} - ${item.paymentName}`;
    },
    updatePaymentMethod(newValue) {
      const payment = this.payAcctList.find(
        (item) => item.payCode === newValue
      );

      this.selectedDoc.payment.paymentAcctCode = newValue;
      console.log("payment:: ", payment);
      if (payment) {
        this.selectedDoc.payment.paymentAcctName = payment?.payName || "";
        this.selectedDoc.payment.acctTypePayment = payment?.tranType || "";
      }
      // อัปเดตข้อมูลอื่น ๆ ตามความจำเป็น
    },
    updateCurrency(newValue) {
      this.selectedDoc.payment.currency = newValue;
    },
    handleMouseMove(event) {
      const rect = event.target.getBoundingClientRect();

      // Calculate percentage positions relative to the element's boundaries
      const x = ((event.clientX - rect.left) / rect.width) * 125;
      const y = ((event.clientY - rect.top) / rect.height) * 125;

      // Clamp the values between 0 and 100 to avoid glitches
      this.mouseX = Math.max(0, Math.min(100, x));
      this.mouseY = Math.max(0, Math.min(100, y));

      this.isZoomed = true;
    },
    handleMouseLeave() {
      this.isZoomed = false;
    },
    async openAddDoclineDialog() {
      await this.getDefaultValueFromVendor(this.selectedDoc.cardCode);
      // this.doclineToEdit = {}; // Ensure it's in add mode

      this.doclineToEditIndex = -1;
      this.isEditModeDocline = false;
      this.isDoclineDialogOpen = true;
    },
    async getDefaultValueFromVendor(cardCode) {
      this.isGettingDefaultVendor = true;

      await fc.db
        .collection(
          `Companies/${this.$route.params.companyId}/PurchaseInvoiceVendors/`
        )
        .doc(`${cardCode}`)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const docData = doc.data();

            this.doclineToEdit = {
              expenseCode: docData.defaultAcctP07?.expData?.expCode || "",
              expenseName: docData.defaultAcctP07?.expData?.expName || "",
              acctCode: docData.defaultAcctP07?.expData?.acctCode || "",
              acctName: docData.defaultAcctP07?.expData?.acctName || "",
              taxCode: docData.defaultAcctP07?.vatData?.vatCode || "",
              whtCode: docData.defaultAcctP07?.whtData?.whtCode || "",
              whtRate: docData.defaultAcctP07?.whtData?.whtRate || "",
            };
          } else {
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });

      this.isGettingDefaultVendor = false;
    },
    openEditDoclineDialog(docline, doclineIndex) {
      this.doclineToEdit = cloneDeep(docline); // Deep copy here
      this.doclineToEditIndex = doclineIndex;
      this.isEditModeDocline = true;
      this.isDoclineDialogOpen = true;
    },
    // Method to handle saving a docline (both add and edit)
    async handleSaveDocline(docline) {
      try {
        if (this.doclineToEditIndex !== -1) {
          // Update the specific docline
          // Directly replace the object in the array
          this.selectedDoc.docLine.splice(this.doclineToEditIndex, 1, docline);
        } else {
          // Adding new docline
          this.selectedDoc.docLine.push(docline);
        }
      } catch (error) {
        console.error("Error saving docline:", error);
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาด บันทึกไม่สําเร็จ",
          color: "error",
        };
      }
    },

    // Method to handle deleting a docline
    async handleDeleteDocline(doclineIndex) {
      try {
        console.log("deleted docline:: ", doclineIndex);
        this.selectedDoc.docLine.splice(doclineIndex, 1);
      } catch (error) {
        console.error("Error deleting docline:", error);
      }
    },
    generateUUIDv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    generateTaxPeriodList() {
      // Generate list for DM (Doc Month) + 6 months using moment.js
      const periods = [];
      const docDate = this.selectedDoc?.docDate;
      const currentTaxPeriod = this.selectedDoc?.docTaxPeriod;
      
      if (!docDate) return [];
      
      // Parse date using moment with English locale
      let baseMoment;
      if (docDate.seconds) {
        // Firestore Timestamp
        baseMoment = moment.unix(docDate.seconds).locale('en');
      } else {
        // Date string or Date object
        baseMoment = moment(docDate).locale('en');
      }
      
      if (!baseMoment.isValid()) return [];
      
      const periodValues = new Set();
      
      // Generate 7 months: current doc month + 6 future months
      for (let i = 0; i < 7; i++) {
        const currentMonth = baseMoment.clone().add(i, 'months');
        
        const year = currentMonth.year(); // Gregorian year
        const month = currentMonth.month() + 1; // moment months are 0-indexed
        const buddhistYear = year + 543;
        const buddhistYearShort = buddhistYear.toString().slice(-2); // Last 2 digits
        
        // Get English month name (short form) using moment - Jan, Feb, Mar, etc.
        const monthNameEn = currentMonth.format('MMM');
        
        const value = currentMonth.format('YYYY-MM');
        periodValues.add(value);
        
        periods.push({
          value: value, // Store as YYYY-MM
          text: `${String(month).padStart(2, '0')}/${buddhistYearShort} (${monthNameEn} ${year})` // Display as 01/68 (Jan 2025)
        });
      }
      
      // Add current tax period if it exists and is not in the list
      if (currentTaxPeriod && !periodValues.has(currentTaxPeriod)) {
        const parts = currentTaxPeriod.split('-');
        if (parts.length === 2) {
          const year = parseInt(parts[0]);
          const month = parseInt(parts[1]);
          
          if (!isNaN(year) && !isNaN(month) && month >= 1 && month <= 12) {
            const buddhistYear = year + 543;
            const buddhistYearShort = buddhistYear.toString().slice(-2);
            
            // Create moment for the current tax period to get English month name
            const taxPeriodMoment = moment(`${year}-${String(month).padStart(2, '0')}-01`).locale('en');
            const monthNameEn = taxPeriodMoment.format('MMM'); // Jan, Feb, Mar, etc.
            
            periods.push({
              value: currentTaxPeriod,
              text: `${String(month).padStart(2, '0')}/${buddhistYearShort} (${monthNameEn} ${year})`
            });
          }
        }
      }
      
      // Sort periods by value (YYYY-MM format)
      periods.sort((a, b) => a.value.localeCompare(b.value));
      
      return periods;
    },
    formatTaxPeriodForDisplay(taxPeriod) {
      // Convert YYYY-MM to MM/YY (Month YYYY)
      if (!taxPeriod || typeof taxPeriod !== 'string') return '';
      
      const parts = taxPeriod.split('-');
      if (parts.length !== 2) return '';
      
      const year = parseInt(parts[0]);
      const month = parseInt(parts[1]);
      
      if (isNaN(year) || isNaN(month)) return '';
      
      const buddhistYear = year + 543;
      const buddhistYearShort = buddhistYear.toString().slice(-2);
      const monthNameTh = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
      
      return `${String(month).padStart(2, '0')}/${buddhistYearShort} (${monthNameTh[month - 1]} ${buddhistYear})`;
    },
     // Helper to check if a value is numeric.
  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  },

  // Recursive diff function that normalizes undefined to an empty string
  // and compares numeric values by their numeric equivalence.
  getDeepDiff(oldObj, newObj) {
    // Helper to replace undefined with empty string
    const normalize = (value) => (value === undefined ? "" : value);

    // Base case: if not both objects (or one is null), compare as primitives.
    if (
      typeof oldObj !== "object" ||
      oldObj === null ||
      typeof newObj !== "object" ||
      newObj === null
    ) {
      const normOld = normalize(oldObj);
      const normNew = normalize(newObj);

      // If both are numeric (or numeric strings), compare them as numbers.
      if (this.isNumeric(normOld) && this.isNumeric(normNew)) {
        if (Number(normOld) === Number(normNew)) {
          return {};
        }
      } else if (_.isEqual(normOld, normNew)) {
        return {};
      }
      return { old: normOld, new: normNew };
    }

    // If both values are arrays, compare them element by element.
    if (Array.isArray(oldObj) && Array.isArray(newObj)) {
      if (oldObj.length !== newObj.length) {
        return { old: normalize(oldObj), new: normalize(newObj) };
      }
      const arrDiff = [];
      for (let i = 0; i < oldObj.length; i++) {
        const diff = this.getDeepDiff(oldObj[i], newObj[i]);
        arrDiff.push(diff);
      }
      // If every element's diff is empty, then there's no diff.
      if (arrDiff.every((item) => Object.keys(item).length === 0)) {
        return {};
      }
      return arrDiff;
    }

    // For objects, compare each key.
    // Define fields to ignore in the diff.
    const ignoreFields = ["@APTRAN_STATUS", "timeCreate", "timeUpdate", "timeLastUpdateBy"];
    const diff = {};
    const keys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)]);
      keys.forEach((key) => {
        if (ignoreFields.includes(key)) return;
        const subDiff = this.getDeepDiff(oldObj[key], newObj[key]);
        if (Object.keys(subDiff).length > 0) {
          diff[key] = subDiff;
        }
      });
      return diff;
    },
  },
  computed: {
    ...mapState({
      selectedCompanyAutoDocConfig: (state) =>
        state.companies.selectedCompanyAutoDocConfig,
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyApVendors: (state) =>
        state.companies.selectedCompanyApVendors,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
      payAcctList: (state) => state.accountspayable.payAcctList,
      expenseList: (state) => state.accountspayable.expenseList,
      whtList: (state) => state.accountspayable.whtList,
      vatList: (state) => state.accountspayable.vatList,
    }),
    isDuplicate() {
      return (this.selectedDoc?.docId === this.selectedDocIdCopy) && this.selectedDoc?.isDuplicate
    },
    isSourceFilterEnabled() {
      return this.$route.params.companyId === "FboSVOrTuPEyZUn1BzYI";
    },
    vendorList() {
      return this.selectedCompanyApVendors.map((vendor) => ({
        venCode: vendor.venCode,
        venName: vendor.venName,
        venLabel: vendor.venLabel,
        venBranch: vendor.venBranch,
      }));
    },
    popupTableHeadersFiltered() {
      return this.popupTableHeaders.filter((item) =>
        this.selectedCompanyProductList?.isApAutomateType === 1
          ? true
          : item.type !== "SAP"
      );
    },
    itemsRangeText() {
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(
        this.currentPage * this.itemsPerPage,
        this.totalItems
      );
      return `${start} - ${end} จาก ${this.totalItems}`;
    },
    formattedPiDate() {
      const date = this.selectedDoc?.docDate
        ? moment(
            this.selectedDoc.docDate.seconds * 1000 || this.selectedDoc.docDate
          )
        : null;

      return date?.isValid() ? date.format("YYYY-MM-DD") : "";
    },
    formattedPiDueDate() {
      const date = this.selectedDoc?.docDueDate
        ? moment(
            this.selectedDoc.docDueDate.seconds * 1000 ||
              this.selectedDoc.docDueDate
          )
        : null;

      return date?.isValid() ? date.format("YYYY-MM-DD") : "";
    },
    formattedPaymentDate() {
      const date = this.selectedDoc?.payment?.paymentDate
        ? moment(
            this.selectedDoc?.payment?.paymentDate.seconds * 1000 ||
              this.selectedDoc?.payment?.paymentDate
          )
        : null;

      return date?.isValid() ? date.format("YYYY-MM-DD") : "";
    },
    formattedVAT() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.VAT);
    },
    formattedSubTotal() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotal);
    },
    formattedSubTotalSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotalSO);
    },
    formattedDiscount() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.Discount);
    },
    formattedDoctotal() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.Doctotal);
    },
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    areItemsSelected() {
      return this.selectedItems.length > 0;
    },
    isDocUnchanged() {
      return _isEqual(this.selectedDoc, this.selectedDocCopy);
    },
    isAccountUnbalanced() {
      return Math.abs(
        Number(this.totalAccountRecordDebit) - Number(this.totalAccountRecordCredit)
      ) >= 0.01;
    },
    currentVendor() {
      return this.selectedCompanyAutoDocConfig.find(
        (item) => item.vendorCode === this.$route.params.vendorId
      );
    },
    imageStyle() {
      if (this.isZoomed) {
        return {
          transform: `scale(1.5)`,
          transformOrigin: `${this.mouseX}% ${this.mouseY}%`,
          transition: "transform 0.3s ease-out",
        };
      }
      return {
        transform: "scale(1)",
        transition: "transform 0.3s ease-out",
      };
    },
      docTotalBeforeDis() {
        if (this.selectedDoc.docLine && this.selectedDoc.docLine.length > 0) {
        const r = this.selectedDoc.docLine
          .map((item) => Number(item.lineTotal) || 0)
          .reduce((a, b) => a + b, 0)
          ?.toFixed(2);

        return r || "0.00";
      }
      return "0.00";
    },
      docTaxAmount() {
        if (this.selectedDoc.docLine && this.selectedDoc.docLine.length > 0) {
        return (
          this.selectedDoc.docLine
            .map((item) => Number(item.taxAmount) || 0)
            .reduce((a, b) => a + b, 0)
            ?.toFixed(2) || "0.00"
        );
      }
      return "0.00";
    },
      docWhtAmount() {
        if (this.selectedDoc.docLine && this.selectedDoc.docLine.length > 0) {
        return (
          this.selectedDoc.docLine
            .map((item) => Number(item.whtAmount) || 0)
            .reduce((a, b) => a + b, 0) || "0.00"
        );
      }
      return "0.00";
    },
    docTotalPayment() {
      if (this.selectedDoc.docLine.length > 0) {
        const r = parseFloat(
          Number(
            this.docTotalBeforeDis -
              Number(this.selectedDoc.totalDisAmount) -
              Number(this.docWhtAmount) +
              Number(this.docTaxAmount)
          )
        ).toFixed(2);
        return isNaN(r) ? "0.00" : r || "0.00";
      }
      return "0.00";
    },
    totalAccountRecordDebit() { 
      return this.buildAccountRecords(this.selectedDoc).reduce((acc, item) => acc + Number(item.totalDebit), 0);
    },
    totalAccountRecordCredit() { 
      return this.buildAccountRecords(this.selectedDoc).reduce((acc, item) => acc + Number(item.totalCredit), 0);
    },
    totalAccountRecordDiff() { 
      return this.totalAccountRecordDebit - this.totalAccountRecordCredit;
    },
    accountRecords() {
        return this.selectedDoc ? this.buildAccountRecords(this.selectedDoc) : [];
    },
    filteredAccountRecords() {
        return this.accountRecords.filter(item => !(item.totalDebit === 0 && item.totalCredit === 0));
    },
    vendorBranch() {
      return this.selectedCompanyApVendors.find(
        (item) => item.venCode === this.selectedDoc.cardCode
      )?.venBranch;
    },
  },
  watch: {
    currentPage() {
      this.paginate();
    },

    selectedDoc() {
      this.selectedPiDate = this.formattedPiDate;
      this.selectedPiDueDate = this.formattedPiDueDate;
      this.selectedPaymentDate = this.formattedPaymentDate;
      this.selectedDoc.docTotal = this.selectedDoc?.payment?.paymentTotal;
      
      // Update tax period list when document changes
      if (this.selectedDoc?.docDate) {
        this.taxPeriodList = this.generateTaxPeriodList();
      }
    },
    'selectedDoc.docDate'() {
      // Regenerate tax period list when document date changes
      this.taxPeriodList = this.generateTaxPeriodList();
    },
    selectedSearchColumn() {
      this.searchKeywords = "";
      this.fetchPurchaseInvoices();
    },
    selectedPiDate(newVal) {
      if (!newVal) {
        this.PiDateDisp = '';
        return;
      }
      // Only update PiDateDisp if the value came from the date picker (has correct format YYYY-MM-DD)
      if (newVal.includes('-')) {
        const parts = newVal.split("-");
        if (parts.length === 3) {
          this.PiDateDisp = `${parts[2]}/${parts[1]}/${parts[0]}`;
          this.selectedDoc.docDate = new Date(newVal);
        }
      }
    },
    PiDateDisp(newVal) {
      // Skip if not in edit mode or if empty
      if (!this.editMode || !newVal) return;

      // Only trigger validation if the user is typing (not from picker)
      if (!this.isOpenPiDateMenu) {
        // Debounce validation to avoid too frequent calls
        clearTimeout(this.piDateValidationTimer);
        this.piDateValidationTimer = setTimeout(() => {
          this.validateAndFormatPiDate();
        }, 1000);
      }
    },

    selectedPiDueDate(newVal) {
      if (!newVal) {
        this.PiDueDateDisp = '';
        this.selectedDoc.docDueDate = '';
        return;
      }
      // Only update PiDueDateDisp if the value came from the date picker (has correct format YYYY-MM-DD)
      if (newVal.includes('-')) {
        const parts = newVal.split("-");
        if (parts.length === 3) {
          // Validate that we have valid date components
          const [yyyy, mm, dd] = parts;
          if (yyyy && mm && dd && yyyy.length === 4 && mm.length === 2 && dd.length === 2) {
            const date = new Date(newVal);
            if (!isNaN(date.getTime())) {
              this.PiDueDateDisp = `${dd}/${mm}/${yyyy}`;
              this.selectedDoc.docDueDate = date;
            }
          }
        }
      }
    },
    PiDueDateDisp(newVal) {
      // Skip if not in edit mode or if empty
      if (!this.editMode || !newVal) return;

      // Only trigger validation if the user is typing (not from picker)
      if (!this.isOpenPiDueDateMenu) {
        // Debounce validation to avoid too frequent calls
        clearTimeout(this.piDueDateValidationTimer);
        this.piDueDateValidationTimer = setTimeout(() => {
          this.validateAndFormatPiDueDate();
        }, 1000);
      }
    },
    selectedPaymentDate(newVal) {
      if (!newVal) {
        this.selectedPaymentDateDisp = '';
        return;
      }
      // Only update selectedPaymentDateDisp if the value came from the date picker (has correct format YYYY-MM-DD)
      if (newVal.includes('-')) {
        const parts = newVal.split("-");
        if (parts.length === 3) {
          this.selectedPaymentDateDisp = `${parts[2]}/${parts[1]}/${parts[0]}`;
          this.selectedDoc.payment.paymentDate = new Date(newVal);
        }
      }
    },
    selectedPaymentDateDisp(newVal) {
      // Skip if not in edit mode
      if (!this.editMode) return;

      // Only trigger validation if the user is typing (not from picker)
      if (!this.isOpenMenuPaymentDate) {
        // Debounce validation to avoid too frequent calls
        clearTimeout(this.paymentDateValidationTimer);
        this.paymentDateValidationTimer = setTimeout(() => {
          this.validateAndFormatPaymentDate();
        }, 1000);
      }
    },
    isOpenCustomDialogue(oldValue, newValue) {
      if (newValue === false) {
        if (
          this.selectedDoc &&
          this.selectedDoc.fileType?.toUpperCase() ===
            INVOICE_FILE_TYPE.DOCUMENT
        ) {
          this.pdfUrl = "";
          this.openPDFFile();
        }
        if (
          this.selectedDoc &&
          this.selectedDoc.fileType?.toUpperCase() === INVOICE_FILE_TYPE.IMAGE
        ) {
          this.imageUrl = "";
          this.openImageFile();
        }
        this.editMode = false;
      }
    },
    selectedItems() {
      if (
        this.selectedItems.length === this.displayedItems.length &&
        this.selectedItems.length > 0 &&
        this.displayedItems.length > 0
      ) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },

    $route: {
      handler() {
        this.intPage();
        // console.log("vendorId:: ", this.vendorId);
        // console.log("companyId:: ", this.companyId);
        this.resetSearchConfig();
        this.fetchPurchaseInvoices();
      },
      deep: true,
    },
  },
  mounted() {

    logActivity("page_view", { page_title: "DocumentAP" });
    this.intPage();
    this.fetchPurchaseInvoices();
    window.addEventListener('keydown', this.handleEscKey);

  },
  beforeDestroy() {
    // Unsubscribe from Firestore updates when component is destroyed
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    window.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>

<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <!-- isLoadingDocs: {{ isLoadingDocs }} -->
      <!-- HI CompanyId:: {{ this.$route.params.companyId }}
      <br/>
      -->

      <!-- firebase.auth().currentUser.uid  -->

      <!-- {{ userCompany?.isDeveloper }} -->

      <!-- payAcctList {{payAcctList}} -->
      <!-- vatList {{vatList}} -->
      <!-- whtList {{whtList}} -->
      <!-- expenseList {{expenseList}} -->
      <!-- selectedCompanyProductList {{selectedCompanyProductList}} -->
      <!-- selectedCompanyProductList {{selectedCompanyProductList?.isApAutomateType}} -->

      <v-container fluid>
        <v-card>
          <!-- Confirmation Dialog for Single Document -->
          <confirm-single-document-dialog
            :is-open="dialogConfirmDocumentOne"
            @update:isOpen="dialogConfirmDocumentOne = $event"
            @confirm="confirmDocumentOne"
          />

          <basic-confirm-dialog
            :is-open="dialogRefreshDocument"
            topic="การดึงข้อมูลอีกครั้ง"
            @update:isOpen="dialogRefreshDocument = $event"
            @confirm="refreshPurchasePdfFile"
          />

          <!-- Confirmation Dialog for Multiple Documents -->
          <confirm-document-dialog
            :is-open="dialogConfirmDocument"
            :selected-items="selectedItems"
            @update:isOpen="dialogConfirmDocument = $event"
            @confirm="confirmDocument"
          />

          <!-- Delete Confirmation Dialog -->
          <confirm-delete-dialog
            :is-open="dialogDelete"
            :docIdLabel="docToDelete?.docId"
            @update:isOpen="dialogDelete = $event"
            @confirm="deleteSelectedItems"
          />

          <div class="table-container">
            <div v-if="vendorId !== ''" class="ma-4">
              <h3 class="tw-text-base">
                <div
                  class="tw-flex tw-items-center tw-gap-2"
                  v-if="currentVendor?.vendorFullName"
                >
                  <img
                    :src="currentVendor?.logo"
                    class="tw-w-8 tw-h-8 tw-object-contain"
                  />
                  {{ currentVendor?.vendorFullName }} - เลขที่ผู้เสียภาษี
                  {{ currentVendor?.taxId }}
                </div>
                <span v-else
                  ><v-icon size="32">mdi-city</v-icon>
                  <v-icon class="mdi-spin">mdi-refresh</v-icon></span
                >
              </h3>
            </div>
            <hr v-if="vendorId !== ''" class="tw-mx-4 tw-pt-2 tw-opacity-10" />
           <div class="pt-8 table-toolbar">
            <v-row class="px-3 pa-0 tw-gap-4" wrap align="center">
                <v-col cols="12" sm="6" md="3" class="pa-0">
                  <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mb-5">
                    <v-btn
                      color="primary"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      @click="openConfirmDialog"
                      :disabled="
                        !areItemsSelected
                      "
                      elevation="0"
                    >
                      <v-icon left>mdi-check</v-icon>
                      ยืนยันเอกสาร
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      outlined
                      @click="exportDialog = true"
                      elevation="0"
                    >
                      <v-icon left>mdi-table-arrow-right</v-icon>
                      ส่งออกข้อมูล
                    </v-btn>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <template>
                  <v-col cols="12" sm="6" md="2" class="pa-0 min-w-0">
                    <v-text-field
                      class="ma-0 pa-0 tw-text-sm"
                      label="ค้นหาเลขที่เอกสาร"
                      dense
                      append-icon="mdi-magnify"
                      v-model="searchDocID"
                      @input="debounceInput"
                      outlined
                      hide-details
                    />
                    <v-checkbox
                      v-model="aiSearchEnabled"
                      label="AI Search"
                      color="primary"
                      dense
                      class="mt-0"
                      hide-details
                      @change="handleAiSearchToggle"
                    ></v-checkbox>
                  </v-col>
                </template>
                <v-col
                  v-if="isSourceFilterEnabled"
                  cols="12"
                  sm="6"
                  md="2"
                  class="pa-0"
                >
                  <v-select
                    :menu-props="{ bottom: true, offsetY: true }"
                    v-model="searchSource"
                    :items="sourceOptions"
                    label="ที่มา (Source)"
                    dense
                    @change="handleStatusSearch"
                    outlined
                  />
                </v-col>

                <!-- ค้นหาช่วงวันที่ -->
                <v-col cols="12" sm="12" md="4" class="pa-0">
                  <date-range-search
                    outline
                    :initial-from-date="searchStartDate"
                    :initial-to-date="searchEndDate"
                    :on-reset="resetDateSearch"
                    :on-search="fetchPurchaseInvoicesByDateRange"
                  />
                </v-col>
              </v-row>
            </div>
            <table class="custom-table tw-text-sm">
             
              <thead>
                <tr>
                  <th>
                    <v-checkbox
                      class="ma-0 pa-0 tw-transform tw-translate-y-3"
                      v-model="selectAll"
                      @change="toggleAll"
                      color="primary"
                    ></v-checkbox>
                  </th>
                  <th>สถานะเอกสาร<br />(Status)</th>
                  <th v-if="isSourceFilterEnabled">ที่มา<br />(Source)</th>
                   <!-- {{ this.pdfUrl }} -->
                  <th class="tw-cursor-pointer" @click="sortTable('docDate')">
                    วันที่เอกสาร<br />(Doc Date)
                    <v-icon v-if="sortBy === 'docDate'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('docId')">
                    เลขที่เอกสาร<br />(Doc No)
                    <v-icon v-if="sortBy === 'docId'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th>รหัสผู้จำหน่าย<br />(Vendor Code)</th>
                  <th class="tw-cursor-pointer" @click="sortTable('cardName')">
                    ชื่อผู้จำหน่าย<br />(Vendor Name)
                    <v-icon v-if="sortBy === 'cardName'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th>รหัสสาขา<br />(Branch Code)</th>
                  <th>เลขที่ผู้เสียภาษี<br />(TaxID)</th>
                  <th class="tw-text-right">
                    มูลค่าก่อนภาษี<br />(Amount before VAT)
                  </th>
                  <th class="tw-text-right">
                    ภาษีมูลค่าเพิ่ม<br />(VAT Amount)
                  </th>
                  <th class="tw-text-right">ภาษีหัก ณ ที่จ่าย<br />(WHT Amount)</th>
                  <th class="tw-text-right">มูลค่ารวม<br />(Net Amount)</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in displayedItems"
                  :key="index"
                  @click="showDocDetailDialog(item)"
                >
                  <td @click.stop>
                    <v-checkbox
                      v-if="item.status === piStatus.PENDING_APPROVAL"
                      class="ma-0 pa-0 tw-transform tw-translate-y-3"
                      v-model="selectedItems"
                      :value="getCheckboxValue(item)"
                    ></v-checkbox>
                  </td>
                  <td class="tw-text-xs">
                    <v-tooltip
                      top
                      v-if="
                        item.failureMessage !== '' &&
                        item.failureMessage !== 'N/A' &&
                        item.failureMessage
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :class="`status-card ${getColorClass(item.status)}`"
                        >
                          {{ getStatusTH(item.status) }}
                        </div>
                      </template>
                      <span>{{ item.failureMessage }}</span>
                    </v-tooltip>
                    <div
                      v-else
                      :class="`status-card ${getColorClass(item.status)}`"
                    >
                      {{ getStatusTH(item.status) }}
                    </div>
                    <v-icon v-if="item?.replaceCount > 3" color="warning">mdi-alert-box-outline</v-icon>
                  </td>
                  <td v-if="isSourceFilterEnabled" class="tw-text-xs">
                    <span
                      :class="`source-stamp ${item?.isManualCreate ? 'source-manual' : 'source-ai'}`"
                    >
                      <v-icon small :color="item?.isManualCreate ? 'blue darken-2' : 'purple darken-2'">
                        {{ item?.isManualCreate ? 'mdi-account-edit' : 'mdi-robot-outline' }}
                      </v-icon>
                      {{ item?.isManualCreate ? 'Manual' : 'AI' }}
                    </span>
                  </td>
                  <td>{{ getThaiDate(item.docDate) }}</td>
                  <!-- click here to copy id -->
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <td
                        @click.stop
                        class="td-copy"
                        v-on="on"
                        @click="copyToClipboard(item?.docId)"
                      >
                        <span style="user-select: none">{{ item?.docId }}</span>
                      </td>
                    </template>
                    <span>
                      <v-icon color="white">mdi-content-copy</v-icon>
                      คลิกเพื่อคัดลอก</span
                    >
                  </v-tooltip>
                  <td>{{ item?.cardCode }}</td>
                  <td>{{ item?.cardName }}</td>
                  <td>{{ item?.branchCode }}</td>
                  <td>{{ item?.taxId }}</td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.totalBeforeDiscount) }}
                  </td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.totalTaxAmount) }}
                  </td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.totalWhtAmount) }}
                  </td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.docTotal) }}
                  </td>
                  <td>
                    <!-- delete button  -->
                    <v-btn
                      v-if="
                        item?.status !== piStatus.POSTING &&
                        item?.status !== piStatus.SUCCESS
                      "
                      icon
                      color="error"
                      class="tw-text-lg"
                      @click.stop="deleteDocument(item)"
                    >
                      <v-icon class="">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-if="purchaseInvoices.length === 0 && !isLoadingDocs"
              class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
            >
              <h2>ไม่พบเอกสารที่ต้องการ</h2>
            </div>
            <v-progress-linear
              indeterminate
              color="green"
              :active="isLoadingDocs"
            ></v-progress-linear>
          </div>
          <!-- Pagination Controls -->
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <div class="tw-px-4">
            {{ itemsRangeText }}
          </div>
          <v-spacer />
          <v-pagination
            v-model="currentPage"
            :length="numPages"
            :total-visible="6"
            @input="paginate"
          ></v-pagination>
          <v-spacer />
        </v-row>
      </v-container>
      <div v-if="isOpenCustomDialogue" class="custom-dialogue">
        <div if="selectedDoc" class="custom-dialogue-content-wrapper">
          <span class="tw-absolute tw-top-12 tw-right-12 tw-text-xs tw-text-gray-500 tw-opacity-50">{{ selectedDoc?.docType }}</span>
          <!-- header title  -->
          <div class="dialog-header-wrapper">
            <div class="tw-flex tw-justify-center tw-items-center tw-gap-2">
              <span
                :class="`status-card-dialogue tw-text-sm  ${getColorClass(
                  selectedDoc.status
                )} `"
              >
                {{ getStatusTH(selectedDoc.status) }}
              </span>
              <span
                v-if="isSourceFilterEnabled"
                :class="`source-stamp ${selectedDoc?.isManualCreate ? 'source-manual' : 'source-ai'}`"
              >
                <v-icon small :color="selectedDoc?.isManualCreate ? 'blue darken-2' : 'purple darken-2'">
                  {{ selectedDoc?.isManualCreate ? 'mdi-account-edit' : 'mdi-robot-outline' }}
                </v-icon>
                {{ selectedDoc?.isManualCreate ? 'Manual' : 'AI' }}
              </span>
            </div>
          </div>
          <!-- content  -->
          <div class="dialog-content-wrapper">
            <div
              v-if="
                selectedDoc &&
                selectedDoc.fileType.toUpperCase() === piFileType.DOCUMENT
              "
              class="dialog-content-left tw-rounded-lg tw-overflow-hidden tw-border-2 tw-bg-pdf-gray"
            >
              <embed
                v-if="pdfUrl"
                :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
                type="application/pdf"
                width="100%"
                height="100%"
              />
              <div
                v-else
                width="100%"
                height="100%"
                class="tw-text-center tw-pt-80"
              >
                <v-icon class="mdi-spin" color="white" size="60"
                  >mdi-refresh</v-icon
                >
              </div>
            </div>
            <div
              v-else
              class="dialog-content-left tw-rounded-lg tw-overflow-hidden tw-border-2 tw-bg-pdf-gray"
            >
              <div
                v-if="isGettingImageData"
                class="tw-h-full tw-w-full tw-flex tw-justify-center tw-items-center"
              >
                <LoadingAnimation />
              </div>
              <div
                v-else
                class="image-container"
                @mousemove="handleMouseMove"
                @mouseleave="handleMouseLeave"
              >
                <img
                  :src="imageUrl"
                  :alt="`image of invoice`"
                  class="invoice-image"
                  :style="imageStyle"
                />
              </div>
            </div>
            <div class="dialog-content-right">
              <div
                class="tw--translate-y-4 tw-tracking-tight tw-transform tw-pt-10 tw-h-full tw-overflow-y-scroll"
              >
              
                <v-row class="mx-2">
                  <v-col cols="8" xs="12" class="py-0">
                    <!-- {{ selectedCompanyApVendors }} -->
                    <v-autocomplete
                      :key="vendorList.length"
                  
                      label="รหัสผู้จำหน่าย (Vendor Code) - ชื่อผู้จำหน่าย (Vendor Name)"
                      dense
                      :disabled="editMode"
                      :readonly="!editMode"
                      v-model="selectedDoc.cardCode"
                      :class="`${(!selectedDoc.cardCode)   ? 'warning-border' : ''} ma-0 pa-0`"
                      :color="(!selectedDoc.cardCode) ? 'orange' : 'primary'"
                      :items="vendorList"
                      item-text="venLabel"
                      item-value="venCode"
                      outlined
                      persistent-placeholder
                    ></v-autocomplete>
                  </v-col>
                  <!-- <v-col cols="4" xs="12" class="py-0">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="ชื่อผู้จำหน่าย (Vendor Name)"
                      :disabled="editMode"
                      persistent-placeholder
                      dense
                      :readonly="!editMode"
                      :value="selectedDoc.cardName"
                      outlined
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="4" xs="12" class="py-0">
                    <v-text-field
                      required
                      dense
                      :readonly="!editMode"
                      maxlength="5"
                      :class="`${(!selectedDoc.cardCode)   ? 'warning-border' : ''} ma-0 pa-0`"
                      :color="(!selectedDoc.cardCode) ? 'orange' : 'primary'"
                      label="รหัสสาขา (Branch Code) *"
                      :value="vendorBranch"
                      :disabled="editMode"
                      persistent-placeholder
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mx-2">
                  <!-- <v-col cols="4" xs="12" class="py-0">
                    <v-text-field
                      required
                      dense
                      class="ma-0 pa-0"
                      :readonly="!editMode"
                      maxlength="5"
                      label="ชื่อสาขา (Branch Name) *"
                      v-model="selectedDoc.branchName"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      dense
                      :class="`${!selectedDoc.cardCode ? 'warning-border' : ''} ma-0 pa-0`"
                      label="เลขประจำตัวผู้เสียภาษี (Tax ID)"
                      :value="selectedDoc?.taxId"
                      outlined
                      :disabled="editMode"
                      persistent-placeholder
                      :readonly="!editMode"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="py-0">
                    <v-text-field
                      dense
                      label="เลขที่เอกสารใบกำกับภาษี (Document Invoice No.)"
                      v-model="selectedDoc.invoiceNo"
                      :disabled="editMode"
                      outlined
                      readonly
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0 tw-relative">
                    <v-text-field
                      v-if="selectedCompanyProductList?.isApAutomateType === 2"
                      dense
                      label="เลขที่เอกสารใบกำกับภาษีจากผู้จำหน่าย (Vendor Document Invoice No.)"
                      v-model="selectedDoc.docId"
                      :class="`${(!selectedDoc.docId || selectedDoc.docId?.length > 15 || isDuplicate)  ? 'warning-border' : ''} ma-0 pa-0`"
                      :color="(!selectedDoc.docId || selectedDoc.docId?.length > 15 || isDuplicate) ? 'orange' : 'primary'"
                      outlined
                      :readonly="!editMode"
                      persistent-placeholder
                    ></v-text-field>
                    <v-text-field
                      v-else
                      dense
                      label="เลขที่เอกสารใบกำกับภาษีจากผู้จำหน่าย (Vendor Document Invoice No.)"
                      v-model="selectedDoc.docId"
                      outlined
                      :readonly="!editMode"
                      persistent-placeholder
                    ></v-text-field>
                    <span 
                    v-if="
                              selectedCompanyProductList?.isApAutomateType === 2
                            "
                    class="tw-absolute tw-text-xs tw-top-11 tw-opacity-60 tw-text-warning">{{ selectedDoc?.docId?.length > 15 ? `รองรับไม่เกิน 15 ตัว (หน้า 5 หลัง 8)` : '' }} {{ isDuplicate ? '; พบเลขที่เอกสารซ้ํา' : '' }}</span>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="4" class="py-0">
                    <v-menu
                      v-model="isOpenPiDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="292px"
                      min-width="292px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="วันที่เอกสาร (Document Date)"
                          append-icon="mdi-calendar-month-outline"
                          :readonly="!editMode"
                          dense
                          v-model="PiDateDisp"
                          outlined
                          :class="`${(!PiDateDisp)   ? 'warning-border' : ''} ma-0 pa-0`"
                          :color="(!PiDateDisp) ? 'orange' : 'primary'"
                          persistent-placeholder
                          v-on="editMode ? on : {}"
                          @click:append="editMode ? (isOpenPiDateMenu = !isOpenPiDateMenu) : null"
                          @blur="validateAndFormatPiDate"
                          placeholder="DD/MM/YYYY"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        dense
                        color="primary"
                        locale="en-in"
                        v-model="selectedPiDate"
                        no-title
                        @input="isOpenPiDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-menu
                      v-model="isOpenPiDueDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="292px"
                      min-width="292px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="วันที่ครบกำหนด (Due Date)"
                          append-icon="mdi-calendar-month-outline"
                          :readonly="!editMode"
                          dense
                          v-model="PiDueDateDisp"
                          class="ma-0 pa-0"
                          outlined
                          persistent-placeholder
                          v-on="editMode ? on : {}"
                          @click:append="editMode ? (isOpenPiDueDateMenu = !isOpenPiDueDateMenu) : null"
                          @blur="validateAndFormatPiDueDate"
                          placeholder="DD/MM/YYYY"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        dense
                        color="primary"
                        locale="en-in"
                        v-model="selectedPiDueDate"
                        no-title
                        @input="isOpenPiDueDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-select
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense
                      label="งวดภาษี (Tax Period)"
                      v-model="selectedDoc.docTaxPeriod"
                      :items="taxPeriodList"
                      item-text="text"
                      item-value="value"
                      outlined
                      :readonly="!editMode"
                      persistent-placeholder
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      dense
                      label="เลขที่เอกสารใบกับภาษีในระบบ Express (Express Invoice No.)"
                      v-model="selectedDoc.invoiceNoExpress"
                      :disabled="editMode"
                      outlined
                      readonly
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="6" xs="12" class="py-0">
                    <v-textarea
                      dense
                      rows="3"
                      label="ที่อยู่ (Address)"
                      v-model="selectedDoc.addressDocFull"
                      :class="`${(!selectedDoc.addressDocFull)   ? 'warning-border' : ''} ma-0 pa-0`"
                      :color="(!selectedDoc.addressDocFull) ? 'orange' : 'primary'"
                      outlined
                      :readonly="!editMode"
                      :disabled="editMode"
                      persistent-placeholder
                    ></v-textarea>
                  </v-col>
                  <!-- <v-col cols="3" xs="6" class="py-0">
                    <v-text-field
                      dense
                      label="เงื่อนไขการจ่ายชำระ (Payment Terms)"
                      v-model="selectedDoc.payment.paymentTerms"
                      outlined
                      :readonly="!editMode"
                      persistent-placeholder
                    ></v-text-field>
                  </v-col> -->
                </v-row>
                <v-row v-if="1 === 2" class="mx-2">
                  <!-- //temporary hide for now -->
                  <v-col cols="3" xs="6" class="py-0">
                    <v-select
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense
                      label="สกุลเงิน (Currency)"
                      v-model="selectedDoc.currency"
                      outlined
                      :readonly="!editMode"
                      :items="currencies"
                      :value="selectedDoc.payment.currency"
                      @input="updateCurrency"
                      item-text="name"
                      item-value="code"
                      no-data-text="ไม่มีข้อมูล"
                      persistent-placeholder
                    ></v-select>
                  </v-col>
                  <v-col cols="3" xs="6" class="py-0">
                    <v-text-field
                      dense
                      label="อัตราแลกเปลี่ยน (Exchang Rate)"
                      v-model="selectedDoc.currencyRate"
                      outlined
                      :readonly="!editMode"
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                </v-row>

                <div class="super-wrapper pa-5">
                  <div class="popup-table-wrapper">
                    <table class="tw-text-sm popup-table">
                      <thead>
                        <tr>
                          <th
                            v-for="(
                              { titleEN = '', titleTH = '' }, index
                            ) of popupTableHeadersFiltered"
                            :key="index"
                            class="tw-whitespace-nowrap tw-bg-light-gray"
                          >
                            {{ titleTH }} <br />
                            {{ titleEN }}
                          </th>
                          <th
                            v-if="selectedDoc?.status === piStatus.PENDING_APPROVAL || selectedDoc?.status === piStatus.WARNING || selectedDoc?.status === piStatus.ERROR"
                            class="tw-whitespace-nowrap tw-bg-light-gray"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        :class="{
                          'tw-text-red-500': checkIfInvalid(doclineItem),
                        }"
                        v-for="(doclineItem, index) in selectedDoc?.docLine"
                        :key="index"
                      >
                        <tr>
                          <td align="center">{{ index + 1 }}</td>
                          <td :class="`tw-text-center ${!doclineItem.expenseCode ? 'warning-td' : ''}`">
                            {{ nAformmater(doclineItem?.expenseCode) }}
                          </td>
                          <td :class="`tw-text-center ${!doclineItem.expenseName ? 'warning-td' : ''}`">
                            {{ nAformmater(doclineItem?.expenseName) }}</td>
                          <td :class="`tw-text-center ${!doclineItem.taxCode ? 'warning-td' : ''}`">
                            {{ nAformmater(doclineItem?.taxCode) }}
                          </td>
                          <td class="tw-text-right">
                            {{ $formatCurrency(doclineItem.lineTotal) }}
                          </td>
                          <td class="tw-text-right">
                            {{
                              $formatCurrency(doclineItem?.taxAmount)
                            }}
                          </td>
                          <td class="tw-text-right">
                            {{
                              $formatCurrency(
                                (
                                  Number(doclineItem.lineTotal) +
                                  Number(
                                    (doclineItem.taxCode === "P00"
                                      ? doclineItem.lineTotal * (0 / 100)
                                      : Math.round(doclineItem.lineTotal * 7) / 100) || 0
                                  )
                                )?.toFixed(2) || "0.00"
                              )
                            }}
                          </td>
                          <td :class="`tw-text-center ${!doclineItem.whtCode && Number(doclineItem.whtRate) > 0 ? 'warning-td' : ''}`">
                            {{ nAformmater(doclineItem.whtCode) }}
                          </td>
                          <td class="tw-text-right">
                            {{ $formatCurrency(doclineItem.whtRate) }}
                          </td>
                          <td
                            v-if="
                              selectedCompanyProductList?.isApAutomateType === 1
                            "
                            class="tw-text-right"
                          >
                            {{ doclineItem.costCenterCode1 }}
                          </td>
                          <td
                            v-if="
                              selectedCompanyProductList?.isApAutomateType === 1
                            "
                            class="tw-text-right"
                          >
                            {{ doclineItem.costCenterCode2 }}
                          </td>
                          <td
                            v-if="
                              selectedCompanyProductList?.isApAutomateType === 1
                            "
                            class="tw-text-right"
                          >
                            {{ doclineItem.costCenterCode3 }}
                          </td>
                          <td
                           v-if="selectedDoc?.status === piStatus.PENDING_APPROVAL || selectedDoc?.status === piStatus.WARNING || selectedDoc?.status === piStatus.ERROR"
                          >
                            <v-btn
                              :disabled="!editMode"
                              icon
                              @click.stop="
                                openEditDoclineDialog(doclineItem, index)
                              "
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              :disabled="!editMode"
                              icon
                              color="error"
                              @click.stop="handleDeleteDocline(index)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="tw-flex tw-mt-3">
                    <v-btn
                      v-if="selectedDoc?.status === piStatus.PENDING_APPROVAL || selectedDoc?.status === piStatus.WARNING || selectedDoc?.status === piStatus.ERROR"
                      class="tw-tracking-normal"
                      color="info"
                      :disabled="!editMode || isUpdating"
                      outlined
                      @click="openAddDoclineDialog"
                      :loading="isGettingDefaultVendor"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      เพิ่มข้อมูล
                    </v-btn>
                  </div>
                </div>
                <div class="tw-mb-8 tw-mt-10">
                  <v-row class="mx-2">
                    <v-col cols="9" xs="12" class="py-0">
                      <v-col cols="6" xs="12" class="py-0">
                        <v-row>
                          <v-menu
                            v-model="isOpenMenuPaymentDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="292px"
                            min-width="292px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                label="วันที่จ่ายชำระ (Payment Date)"
                                append-icon="mdi-calendar-month-outline"
                                :readonly="!editMode"
                                dense
                                v-model="selectedPaymentDateDisp"
                                :class="`${(!selectedPaymentDateDisp)   ? 'warning-border' : ''} ma-0 pa-0`"
                                :color="(!selectedPaymentDateDisp) ? 'orange' : 'primary'"
                                outlined
                                persistent-placeholder
                                v-on="editMode ? on : {}"
                                @click:append="editMode ? (isOpenMenuPaymentDate = !isOpenMenuPaymentDate) : null"
                                @blur="validateAndFormatPaymentDate"
                                placeholder="DD/MM/YYYY"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              dense
                              color="primary"
                              locale="en-in"
                              v-model="selectedPaymentDate"
                              no-title
                              @input="isOpenMenuPaymentDate = false"
                            ></v-date-picker>
                          </v-menu>
                          <v-select
                            :menu-props="{ bottom: true, offsetY: true }"
                            dense
                            class="ma-0 pa-0"
                            label="วิธีการจ่ายชำระ (Payment Method)"
                            :items="payAcctList"
                            :value="selectedDoc.payment.paymentAcctCode"
                            @input="updatePaymentMethod"
                            :item-text="
                              (payAcct) =>
                                `${payAcct.payName} - ${payAcct.payCode}`
                            "
                            item-value="payCode"
                            no-data-text="ไม่มีข้อมูล"
                            outlined
                            :readonly="!editMode"
                            persistent-placeholder
                          >
                          </v-select>
                        </v-row>
                      </v-col>
                      <v-col cols="8" xs="12" class="py-0 tw-mt-2 tw-relative">
                        <v-row>
                          <v-textarea
                            v-if="
                              selectedCompanyProductList?.isApAutomateType === 2
                            "
                            class="ma-0 pa-0"
                            label="หมายเหตุ (Remark)"
                            dense
                            :readonly="!editMode"
                            v-model="selectedDoc.remark"
                            persistent-placeholder
                            outlined
                                   :class="`${(!selectedDoc?.remark || selectedDoc?.remark?.length > 30)   ? 'warning-border' : ''} ma-0 pa-0`"
                      :color="(!selectedDoc?.remark || selectedDoc?.remark?.length > 30) ? 'orange' : 'primary'"
                            rows="3"
                          ></v-textarea>
                          <v-textarea
                            v-else
                            class="ma-0 pa-0"
                            label="หมายเหตุ (Remark)"
                            dense
                            :readonly="!editMode"
                            v-model="selectedDoc.remark"
                            persistent-placeholder
                            outlined
                            rows="3"
                          ></v-textarea>
                            <span 
                            v-if="
                              selectedCompanyProductList?.isApAutomateType === 2
                            "
                            class="tw-absolute tw-text-xs tw-top-24 tw-opacity-60 tw-text-warning">{{ selectedDoc?.remark?.length > 30 ? `รองรับไม่เกิน 30 ตัว` : '' }}</span>
                        </v-row>
                      </v-col>

                      <p class="tw-mb-4 tw-mt-2">การบันทึกบัญชี</p>

                      <!-- accountRecords {{accountRecords}} -->

                      <v-col cols="10" lg="12" class="pt-2 pb-0 tw-mt-2">
                        <v-row>
                          <div class="tw-w-full">
                            <div
                              class="tw-border tw-h-30 tw-bg-white tw-border-gray-300 tw-rounded-lg tw-shadow-sm tw-overflow-hidden"
                            >
                              <div class="tw-overflow-x-auto">
                                <table class="tw-w-full">
                                  <thead class="tw-bg-light-gray">
                                    <tr class="tw-border-b tw-border-gray-300">
                                      <th
                                        scope="col"
                                        class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500-500 tw-tracking-wider"
                                      >
                                        <span class="tw-block">รหัสบัญชี</span>
                                        <span class="tw-block tw-text-gray-500-400"
                                          >(Acct Code)</span
                                        >
                                      </th>
                                      <th
                                        scope="col"
                                        class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500-500 tw-tracking-wider"
                                      >
                                        <span class="tw-block">ชื่อบัญชี</span>
                                        <span class="tw-block tw-text-gray-500-400"
                                          >(Acct Name)</span
                                        >
                                      </th>
                                      <th
                                        scope="col"
                                        class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500-500 tw-tracking-wider"
                                      >
                                        <span class="tw-block">เดบิต</span>
                                        <span class="tw-block tw-text-gray-500-400"
                                          >(Debit)</span
                                        >
                                      </th>
                                      <th
                                        scope="col"
                                        class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500-500 tw-tracking-wider"
                                      >
                                        <span class="tw-block">เครดิต</span>
                                        <span class="tw-block tw-text-gray-500-400"
                                          >(Credit)</span
                                        >
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody class="tw-divide-y tw-divide-gray">
                                    <!-- Add v-for here when you have data -->
                                    <tr
                                      v-for="(item, index) in filteredAccountRecords"
                                      :key="index"
                                      class="hover:tw-bg-gray-50"
                                    >
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900"
                                      >
                                        {{ item.acctCode }}
                                      </td>
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900"
                                      >
                                        {{ item.acctName }}
                                      </td>
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900"
                                        :class="`${selectedDoc.failureMessage?.includes('ยอดรวมคู่บัญชีไม่ตรงกัน') ? 'tw-text-red-500' : ''}`"
                                      >
                                        {{
                                          $formatCurrency(item.totalDebit) ===
                                          "0.00"
                                            ? ""
                                            : $formatCurrency(item.totalDebit)
                                        }}
                                      </td>
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900"
                                        :class="`${selectedDoc.failureMessage?.includes('ยอดรวมคู่บัญชีไม่ตรงกัน') ? 'tw-text-red-500' : ''}`"
                                      >
                                        {{
                                          $formatCurrency(item.totalCredit) ==
                                          "0.00"
                                            ? ""
                                            : $formatCurrency(item.totalCredit)
                                        }}
                                      </td>
                                    </tr>
                                    <tr
                                      class="hover:tw-bg-gray-50"
                                    >
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900 tw-font-bold"
                                      >
                                      ยอด Diff / ยอดรวม
                                      </td>
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900 tw-font-bold"
                                      >
                                      {{ $formatCurrency(totalAccountRecordDiff) === "0.00" ? "" : $formatCurrency(totalAccountRecordDiff) }}
                                      </td>
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900 tw-font-bold"
                                      >
                                      {{ $formatCurrency(totalAccountRecordDebit) }}
                                      </td>
                                      <td
                                        class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500-900 tw-font-bold"
                                      >
                                      {{ $formatCurrency(totalAccountRecordCredit) }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </v-row>
                      </v-col>

                    
                    </v-col>
                    <v-col cols="3" xs="12" class="py-0">
                      <v-col cols="12" xs="12" class="py-0">
                        <v-row>
                          <v-text-field
                            class="ma-0 pa-0"
                            label="มูลค่าก่อนภาษี (Amount before VAT)"
                            dense
                            persistent-placeholder
                              :class="`${(!docTotalBeforeDis)   ? 'warning-border' : ''} ma-0 pa-0`"
                                :color="(!docTotalBeforeDis) ? 'orange' : 'primary'"
                            readonly
                            :disabled="editMode"
                            :value="
                              editMode
                                ? docTotalBeforeDis
                                : $formatCurrency(docTotalBeforeDis)
                            "
                            type="text"
                            format="number"
                            reverse
                            outlined
                          />

                          <v-text-field
                            v-if="editMode"
                            class="ma-0 pa-0"
                            label="ส่วนลด (Discount)"
                            dense
                            v-model="selectedDoc.totalDisAmount"
                            type="text"
                            persistent-placeholder
                            :readonly="!editMode"
                            reverse
                            outlined
                          />

                          <v-text-field
                            class="ma-0 pa-0"
                            label="ส่วนลด (Discount)"
                            dense
                            :value="$formatCurrency(selectedDoc.totalDisAmount)"
                            type="text"
                            persistent-placeholder
                            v-if="!editMode"
                            :readonly="true"
                            reverse
                            outlined
                          />

                         
                          <v-text-field
                            class="ma-0 pa-0"
                            label="ภาษีมูลค่าเพิ่ม (VAT)"
                            dense
                            :value="
                              editMode
                                ? docTaxAmount
                                : $formatCurrency(docTaxAmount)
                            "
                            persistent-placeholder
                            :disabled="editMode"
                            readonly
                            type="text"
                            reverse
                            outlined
                          />

                          <v-text-field
                            class="ma-0 pa-0"
                            label="ภาษีหัก ณ ที่จ่าย (WHT)"
                            dense
                            :value="
                              editMode
                                ? docWhtAmount
                                : $formatCurrency(docWhtAmount)
                            "
                            persistent-placeholder
                             readonly
                            :disabled="editMode"
                            type="text"
                            reverse
                            outlined
                          />
                          <v-text-field
                            class="ma-0 pa-0"
                            label="มูลค่ารวม (Net Amount)"
                            persistent-placeholder
                             readonly
                            :disabled="editMode"
                            dense
                              :class="`${(!docTotalPayment)   ? 'warning-border' : ''} ma-0 pa-0`"
                                :color="(!docTotalPayment) ? 'orange' : 'primary'"
                            reverse
                            :value="
                              editMode
                                ? docTotalPayment
                                : $formatCurrency(docTotalPayment)
                            "
                            type="text"
                            outlined
                          />
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="isDuplicate"
                    class="mx-2 tw-mt-12"
                  >
                  <!-- && -->
                  <!-- selectedDoc.status === 'WARNING' -->
                    <v-col cols="12" xs="12" class="py-0">
                      <label for="">ตรวจพบเลขที่เอกสารซ้ํา</label>
                      <div class="duppBox tw-mt-4 tw-p-4 tw-text-white tw-rounded-2xl">
                        <p class="ma-0 pa-0">
                          {{ selectedDoc.isDuplicateType === 1 ? "เลขที่เอกสารซ้ํา กรุณาตรวจสอบอีกครั้ง" : "เลขที่เอกสารซ้ํากับผู้จําหน่ายอื่น กรุณาตรวจสอบอีกครั้ง" }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="selectedDoc?.replaceCount > 3"
                    class="mx-2 tw-mt-12"
                  >
                  <!-- && -->
                  <!-- selectedDoc.status === 'WARNING' -->
                    <v-col cols="12" xs="12" class="py-0">
                      <label for="">เอกสารวางช้ำ</label>
                      <div class="duppBox tw-mt-4 tw-p-4 tw-text-white tw-rounded-2xl">
                        <p class="ma-0 pa-0">
                          ตรวจพบเอกสารวางช้ำเป็นจำนวนมาก กรุณาตรวจสอบความถูกต้องอีกครั้ง
                        </p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      selectedDoc.failureMessage &&
                      selectedDoc.status === 'ERROR'
                    "
                    class="mx-2 tw-mt-12"
                  >
                    <v-col cols="12" xs="12" class="py-0">
                      <label for="">ตรวจพบข้อผิดพลาด</label>
                      <div
                        class="errorBox tw-mt-4 tw-p-4 tw-rounded"
                      >
                        <p class="ma-0 pa-0">
                          {{ selectedDoc.failureMessage }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="selectedDoc?.failureMessage && selectedDoc.status === 'WARNING'"
                    class="mx-2 tw-mt-12"
                  >
             
                    <v-col cols="12" xs="12" class="py-0">
                      <label for="">ตรวจพบข้อผิดพลาด</label>
                      <div class="duppBox tw-mt-4 tw-p-4 tw-text-white tw-rounded-2xl">
                        <p class="ma-0 pa-0">
                          {{ selectedDoc.failureMessage }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>

                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer-wrapper tw-flex tw-flex-wrap tw-gap-2">
            <v-btn
              v-if="this.selectedDoc.status === 'PENDING_APPROVAL'"
              class="tw-tracking-normal"
              color="primary"
              @click="openConfirmOneDialog"
              :loading="isConfirmingDoc"
              :disabled="editMode || isUpdating || isRefreshingDoc || isConfirmingDoc"
            >
              <v-icon left>mdi-check</v-icon>
              ยืนยันเอกสาร</v-btn
            >
            <!-- <v-btn
              v-if="
                this.selectedDoc.status !== piStatus.POSTING &&
                this.selectedDoc.status !== piStatus.PENDING_APPROVAL &&
                this.selectedDoc.status !== piStatus.SUCCESS
              "
              color="indigo"
              class="tw-tracking-normal tw-text-white"
              @click="setNewDocStatus"
            >
              <v-icon left>mdi-refresh</v-icon>
              แมตช์ข้อมูลใหม่
            </v-btn> -->
            <v-spacer></v-spacer>

            <v-btn
              v-if="userCompany?.isDeveloper || user?.isEngineer"
              color="brown"
              class="tw-tracking-normal tw-text-white"
              text
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              @click="downloadExtractedText(selectedDoc.id)"
            >
              <v-icon left>mdi-note-text-outline</v-icon>
              ไฟล์ข้อความ</v-btn
            >

         

            <v-btn
              v-if="userCompany?.isDeveloper || user?.isEngineer"
              color="blue-grey"
              text
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              class="tw-tracking-normal tw-text-white"
              @click="downloadJson(selectedDoc.id)"
            >
              <v-icon left>mdi-code-json</v-icon>
              ไฟล์เจซัน</v-btn
            >

            <v-btn
              v-if="selectedDoc && selectedDoc.fileType?.toUpperCase() === piFileType.DOCUMENT && pdfUrl"
              color="red"
              text
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc || isGettingPdfData"
              class="tw-tracking-normal tw-text-white"
              @click="downloadPdf"
            >
              <v-icon left>mdi-file-pdf-box</v-icon>
              ดาวน์โหลด PDF</v-btn
            >

            <v-btn
              v-if="userCompany?.isDeveloper || user?.isEngineer"
              color="indigo"
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              class="tw-tracking-normal tw-text-white"
              text
              @click="openExternalFirebaseLink"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.4em"
                height="1.4em"
                viewBox="0 0 27 27"
              >
                <path
                  fill="currentColor"
                  d="m20 18.69l-7.3 4.05q-.75.39-1.5 0L4 18.69L17.05 5.54l.35-.1c.3 0 .47.13.5.4zM9.35 5.74L4.8 13.29L6.7 1.34c.03-.27.2-.4.5-.4c.2 0 .33.06.4.25l2.15 3.95zM13.85 7L4.3 16.59l7.25-12.3c.1-.2.25-.29.45-.29s.33.09.4.29z"
                />
              </svg>

              <span class="tw-ml-l">ข้อมูลบนคลาวด์</span></v-btn
            >

            <!-- <v-btn
              v-if="userCompany?.isDeveloper || user?.isEngineer"
              color="brown"
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              text
              class="tw-tracking-normal tw-text-white"
              @click="copyExternalDocId"
            >
              <v-icon left>mdi-content-copy</v-icon>
              คัดลอกไอดี</v-btn
            > -->
            <v-btn
              v-if="
                ((userCompany?.isDeveloper || user?.isEngineer) &&
                  selectedDoc.status === piStatus.PENDING_APPROVAL || selectedDoc.status === piStatus.ERROR || selectedDoc.status === piStatus.WARNING)
              "
              color="teal"
              class="tw-tracking-normal tw-text-white"
              text
              :loading="isRefreshingDoc"
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              @click="openRefreshDocument"
            >
              <v-icon left>mdi-cloud-refresh-outline</v-icon>
              ดึงข้อมูลอีกครั้ง</v-btn
            >

            <v-btn
              v-if="
                this.selectedDoc.status === 'PENDING_APPROVAL' ||
                this.selectedDoc.status === 'ERROR' ||
                this.selectedDoc.status === 'WARNING'
              "
              :disabled="isUpdating || isRefreshingDoc || isConfirmingDoc"
              :color="editMode ? 'error' : 'warning'"
              class="tw-tracking-normal"
              text
              @click="toggleEditMode"
            >
              <v-icon left>mdi-pencil</v-icon>
              {{ editMode ? "ยกเลิก" : "แก้ไข" }}
            </v-btn>
            <!-- Update button -->
            <v-btn
              v-if="editMode"
              :disabled="isUpdating || isDocUnchanged || isRefreshingDoc || isConfirmingDoc || isAccountUnbalanced"
              color="info"
              class="tw-tracking-normal"
              :loading="isUpdating"
              text
              @click="updateDocument"
            >
              <v-icon left>mdi-content-save</v-icon>
              {{ isUpdating ? "กำลังบันทึก" : isAccountUnbalanced ? "ยอด Dr/Cr ไม่ตรง" : " บันทึก" }}
            </v-btn>
            <v-btn
              v-if="!editMode"
              :disabled="isUpdating || isRefreshingDoc  || isConfirmingDoc"
              class="tw-tracking-normal"
              text
              @click="isOpenCustomDialogue = false"
            >
              <v-icon left>mdi-close</v-icon>
              ปิด</v-btn
            >
          </div>
        </div>
      </div>

      <!-- Docline Form Dialog -->
      <docline-form-dialog
        :isOpen="isDoclineDialogOpen"
        :docline="doclineToEdit"
        :expenseList="expenseList"
        :vatList="vatList"
        :whtList="whtList"
        :isEditMode="isEditModeDocline"
        :companyID="companyId"
        :cardCode="selectedDoc?.cardCode || ''"
        @update:isOpen="isDoclineDialogOpen = $event"
        @save="handleSaveDocline"
      />
    </v-main>

    <v-snackbar
      timeout="2500"
      v-model="snackbar.isShow"
      :color="snackbar.color"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.msg }}
    </v-snackbar>

    <v-dialog v-model="exportDialog" persistent max-width="400px">
      <v-form ref="form">
        <v-card>
          <v-card-title>
            <b>ส่งออกข้อมูล</b>
          </v-card-title>
          <v-card-text class="tw-pb-0">
            <v-menu
              v-model="menuDatePickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="dateExportStart"
                  label="วันที่เอกสารเริ่มต้น"
                  append-icon="mdi-calendar"
                  persistent-placeholder
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateExportStart"
                @input="menuDatePickerStart = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              v-model="menuDatePickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="dateExportEnd"
                  persistent-placeholder
                  label="วันที่เอกสารสิ้นสุด"
                  append-icon="mdi-calendar"
                  :disabled="!dateExportStart"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateExportEnd"
                :allowed-dates="
                  (date) => new Date(date) >= new Date(dateExportStart)
                "
                @input="menuDatePickerEnd = false"
              ></v-date-picker>
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cancelExportDocs">
              <v-icon>mdi-close-circle-outline</v-icon>
              <b>ยกเลิก</b>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="#6ec39b"
              type="button"
              class="btn-submit"
              :disabled="!dateExportStart || !dateExportEnd"
              @click="exportDocs"
            >
              <b>ส่งออกข้อมูล</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </Admin>
</template>

<style lang="scss" scoped>
* {
  --warning-color: rgb(255, 178, 76);
  --warning-bg-color: rgb(255, 178, 77, 0.2);
  --error-color: rgb(173, 15, 1);
  --error-bg-color: rgb(173, 15, 1, 0.2);
  --pending-color: rgb(97, 163, 255);
  --pending-bg-color: rgba(97, 163, 255, 0.2);
  --posting-color: rgb(159, 152, 255);
  --posting-bg-color: rgba(159, 152, 255, 0.2);
  --fetching-color: #777a82;
  --fetching-bg-color: rgba(119, 122, 130, 0.2);
  --new-color: #4794eb;
  --new-bg-color: rgba(71, 148, 235, 0.2);
  --text-color: #ffffff;
  --success-color: #0fb45f;
  --success-bg-color: rgba(15, 180, 95, 0.2);
}

.warning-border {
  ::v-deep fieldset {
    border-color: orange !important;
    border-width: 2px !important;
  }
}

.errorBox {
  color: red;
  border: 2px solid red;
  background: white;
}

.duppBox {
  color: rgb(241, 157, 0);
  border: 2px solid rgb(241, 157, 0);
  background: white;
  font-weight: bold;
}

.duppBox p{
  color: rgb(241, 157, 0);
}

.errorBox:hover {
  animation: none;
}


.custom-button {
  cursor: pointer;
  /* border: 2px solid red; */
  padding: 0.5rem 1rem;
}

.custom-button:active {
  opacity: 50%;
}

.error-color {
  color: var(--error-color);
  background-color: var(--error-bg-color);
  display: inline-block;
}

.success-color {
  color: var(--success-color);
  background-color: var(--success-bg-color);
  display: inline-block;
}

.warning-color {
  color: var(--warning-color);
  background-color: var(--warning-bg-color);
  display: inline-block;
}

.fetching-color {
  color: var(--fetching-color);
  background-color: var(--fetching-bg-color);
  display: inline-block;
}

.pending-color {
  color: var(--pending-color);
  background-color: var(--pending-bg-color);
  display: inline-block;
}
.new-color {
  color: var(--new-color);
  background-color: var(--new-bg-color);
  display: inline-block;
}

.posting-color {
  color: var(--posting-color);
  background-color: var(--posting-bg-color);
  display: inline-block;
}

.status-card {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  max-width: 200px;
}
.status-card-dialogue {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
}
.source-stamp {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 1rem;
  padding: 0.25rem 0.75rem;
  font-weight: 600;
  border: 1px solid;
  font-size: 0.75rem;
}
.source-ai {
  color: #6a1b9a;
  background-color: #f3e5f5;
  border-color: #e1bee7;
}
.source-manual {
  color: #1565c0;
  background-color: #e3f2fd;
  border-color: #bbdefb;
}
/* Additional styling for the table */
.table-container {
  width: 100%; /* Adjust the width as needed */
  overflow-x: auto;

  td,
  th {
    white-space: nowrap;
  }
}

.table-container-detail {
  width: 100%; /* Adjust the width as needed */
  border: 2px solid red;
  overflow: hidden;
}

.customer-table-detail {
  width: calc(100% - 2.7rem);
  /* border: 2px solid red; */
}

/* Styling for table headers */
.customer-table-detail th {
  padding: 10px;
  text-align: left;
}

/* Styling for table cells */
.customer-table-detail td {
  padding: 10px;
  height: 40px;
  border: 1px solid rgba(182, 182, 182, 0.528);
}

/* Styling for table rows */
.customer-table-detail tbody tr {
  padding: 10px; /* Add padding to each row */
}
.customer-table-detail tbody {
  border-bottom: 2px solid rgb(182, 182, 182);
}
.customer-table-detail tbody:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}
.customer-table-detail tbody:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

/* ---------------------- */

.table-toolbar {
  padding: 1rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100%; /* Make table width 100% of container */
  overflow: hidden;
}

/* Styling for table headers */
.custom-table th {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
  font-weight: 400;
}

/* Styling for table cells */
.custom-table td {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
}

/* Styling for table rows */
.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 10px; /* Add padding to each row */
  height: 3rem; /* Add height to each row */
}

.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}

.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

.custom-dialogue {
  position: fixed;
  z-index: 99;
  padding: 1.5rem;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s;
}

.custom-dialogue-content-wrapper {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  height: 100%;
  width: 100%;
  /* border: 5px solid green; */
}

.dialog-header-wrapper {
  /* border: 2px solid green; */
  height: 2.7rem;
}

/* Default styles for .dialog-content-wrapper */
.dialog-content-wrapper {
  /* border: 2px solid red; */
  display: flex;
  padding: 8px 0px;
  height: calc(100% - 2.7rem * 2);
  width: 100%;
}

.dialog-content-left {
  /* border: 2px solid red; */
  width: 35%;
}

.dialog-content-right {
  /* border: 2px solid green; */
  min-width: 65%;
  flex: 1;
  box-sizing: border-box;
}

@media (max-width: 947px) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
    max-width: 40%; /* Ensures left side doesn't exceed 50% width */
  }

  .dialog-content-right {
    /* border: 2px solid green; */
    height: calc(60% - 2.7rem);
  }
}

.dialog-footer-wrapper {
  /* border: 2px solid blue; */
  height: 2.7rem;
}

.image-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-container:hover {
  cursor: zoom-in;
}

.invoice-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.3s;
}

.td-copy:hover {
  background-color: #f2f2f2;
}

.td-copy:active {
  background-color: #e2dfdf;
}

.popup-table-wrapper {
  overflow-x: auto; /* Allows horizontal scrolling if the table overflows */
  width: 100%; /* Ensures the table takes up the full width of the left-side container */
}

/* WebKit Browsers (Chrome, Safari, Edge) */
.popup-table-wrapper::-webkit-scrollbar {
  height: 10px; /* Makes the scrollbar even thinner */
}

.popup-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1; /* Optional: scrollbar track color */
}

.popup-table-wrapper::-webkit-scrollbar-thumb {
  background: #b8b8b8; /* Scrollbar thumb color */
  border-radius: 10px; /* Makes the scrollbar thumb more rounded */
}

.popup-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #616161; /* Changes thumb color on hover */
}

.popup-table {
  white-space: nowrap; /* Prevents table content from wrapping */
  width: 100%; /* Ensures the table spans the full width of its container */
  border-collapse: collapse;
}

.popup-table th,
.popup-table td {
  padding: 10px; /* Optional: for table cell padding */
  border: 1px solid #ddd; /* Optional: for table cell borders */
  font-weight: 500;
}

.warning-td {
  border: 2px solid red !important;
}

@media screen and (max-width: 947px), screen and (orientation: portrait) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
    margin-bottom: 1rem;
  }

  .dialog-content-right {
    width: 100%;
    height: auto;
    overflow-y: auto;
  }
}

</style>
